import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Auth } from 'aws-amplify';
import AWS from "aws-sdk";
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import React, { Fragment, useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import awsmobile from "../../../../aws-exports";
import Layout from "../../../../components/common/nav/initiator/nav.component";
import { ConvertResponseForSelect, ConvertResponseForSelectWithRefCode, checkDuplicates, getResponseFromKeyCertifiedAdmin, graphQLGetAllData, graphQLFindRecordById, removeDuplicateApprover } from '../../../../helper/commonfunctions';
import { Request_Status, USER_TYPES, USER_TYPES_NAMES } from '../../../../helper/enum';
import { ValidateApproverRole, ValidateInitiatorAndApproverRole, ValidateInitiatorRole } from '../../../../helper/validateRole';
import {
    AbsentCode,
    CertificatedAdminWeeklyAbsenceReport,
    CertificatedAdminWeeklyAbsenceReportEmployee,
    Employee,
    CertificatedAdminWeeklyAbsenceReportStatus,
    Schools,
    CertificatedAdminWeeklyAbsenceReportEmployeeDetails,
} from '../../../../models';
import Login from '../../../../setup/auth/login.component';
import { InputText } from 'primereact/inputtext';
import { dark } from '@mui/material/styles/createPalette';
import { handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin } from '../../../../components/actions/notficationActions';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../../graphql/mutations';
import * as queries from "../../../../graphql/queries";
import { Checkbox } from "primereact/checkbox";
import { designationForAllApps } from '../../../../helper/enum';
import capitalizeFirstChar from '../../../../components/common/capitalizeFirstChar'

export default function WAR_Certificated_Admin_Initiate_Request() {


    // table configs starts
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const [isPendingRequest, setIsPendingRequest] = useState(false);

    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const loggedUserRole = reactLocalStorage.get('loggedUserRole');
    const loggedl1authority = reactLocalStorage.get('loggedl1authority');
    let loggedl2authority = reactLocalStorage.get('loggedl2authority');

    const { reportId,type } = useParams();
    const [periodDates, setPeriodDates] = useState([]);
    const [oldPeriodDates, setOldPeriodDates] = useState([]);
    console.log("periodDatesperiodDates 1:-",periodDates);

    const [selectedEmpDate, setSelectedEmpDate] = useState([]);
    const [approver_status, setApproverStatus] = useState("");
    const [remark, setRemark] = useState('');
    const [status, setStatus] = useState('');
    const [schoolList, setSchoolList] = useState([]);
    const [allSchoolList, setAllSchoolList] = useState([]);
    const [absentCodeList, setAbsentCodeList] = useState([]);
    const [absentCodeListDropdown, setAbsentCodeListDropdown] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [absentCode, setAbsentCode] = useState([]);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [absentDate, setAbsentDate] = useState([]);
    console.log("absentDateabsentDate",absentDate);

    const [visible, setVisible] = useState(false);
    const [employeeList, setEmployeeList] = useState();
    const [allEmployeeList, setAllEmployeeList] = useState();
    const [updatedEmpList, setUpdatedEmpList] = useState();
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let navigateTo = useNavigate();
    const [visibleSumbit, setVisibleSumbit] = useState(false);
    const [visibleDialogue, setVisibleDialogue] = useState(false);
    const [mappedData, setMappedData] = useState([]);
    const [administratorData, setAdministratorData] = useState([]);
    const [CertificatedDatas, setCertificatedDatas] = useState([]);
    const existingResultsAdministrator = mappedData.filter(item => (item.employeeType === 'Administrator' ||
        item.employeeType === 'Administratoristrator' || item.employeeType === 'Admin'));
  
    var existingResultsCertifiedCertificated = mappedData.filter(item => item.employeeType === 'Certificated');
    const [selectedDateRecord, setSelectedDateRecord] = useState([]);

    const [selectedDateFinal, setSelectedDateFinal] = useState([]);
    //set employee type list 
    const employeeTypeList = [{ name: "Administrator", code: "Administrator" }, { name: "Certificated", code: "Certificated" }]
    const [employeeTypeField, setEmployeeTypeField] = useState("");


    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [dateCount, setDateCount] = useState(0);
    const [isShowSelectedDate, setIsShowSelectedDate] = useState(false);
    const [SelectperiodExpand, setActivate] = useState("");
    const toggleActiveexpand = () => { setActivate(SelectperiodExpand === "SelectperiodExpand" ? "" : "SelectperiodExpand") };
    const [SPUsersWithoutAdmin, setSPUsersWithoutAdmin] = useState([]);
    const [users, SetUsersList] = useState([]);
    const [payrollUser, setPayrollUserList] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);
    const [skipDisable, setSkipDisable] = useState('');
    const [indexEditMode, setIndexEditMode] = useState(false);


    const [indexEdit, setIndexEdit] = useState('');
    const [detailIndexEdit, setDetailIndexEdit] = useState('');
    const [isApply, setApply] = useState(false);
    const [employeeWiseMapp, setEmployeeWiseMapp] = useState('');
    const [buttonClicked, setButtonClicked] = useState(false);
    const [mapDataIndex, setMapDataIndex] = useState(0);
    const [warCerReqIsSuperadmin, setWarCerReqIsSuperadmin] = useState(0);
    const [isNoAbsence, setIsNoAbsence] = useState(false);
    const [comment, setComment] = useState('');

    const fullDay = "Full Day";
    const [openNewEmployee, setOpenNewEmployee] = useState(false);
    const [NewEmployeeSchool, setNewEmployeeSchool] = useState(null);
    // const [NewEmployeeName, setNewEmployeeName] = useState('');

    const [newEmpFirstName, setNewEmpFirstName] = useState('');
    const [newEmpLastName, setNewEmpLastName] = useState('');
    const rolesArray = [
        { name: 'Initiator', code: 'I' },
        { name: 'Approver', code: 'AP' },
        { name: 'Payroll', code: 'P' },
    ];
    const [newEmpSelectedRole, setNewEmpSelectedRole] = useState(null);
    const [newEmpSelectedDesignation, setNewEmpSelectedDesignation] = useState(null);


    const [NewEmployeeCode, setNewEmployeeCode] = useState('');
    const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);
    //set Roving Substitute email 
    const [rovingSubstituteEmail, setRovingSubstituteEmail] = useState(process.env.REACT_APP_ROVINGSUBS_Email);


    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    const [l1UserList, Setl1UserList] = useState([]);
    // const [allUserList, setAllUsersList] = useState([]);
    const [allApproverList, setAllApproverList] = useState([]);
    const [selectApprover, setSelectApprover] = useState({});
    const [isDisabledApprover, setIsDisabledApprover] = useState(false);
    const particulerReportAllTransactionCycleRecord =async ()=>{

        let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listWARCertificatedTransactionCycles", [{ reportId: { eq: reportId } }]);
        console.log('particulerReportAllTransactionCycleRecord :>> ', particulerReportAllTransactionCycleRecord);
        console.log('selectApprover :>> ', selectApprover);
        if(particulerReportAllTransactionCycleRecord?.length>0){
            particulerReportAllTransactionCycleRecord=particulerReportAllTransactionCycleRecord.sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt))
            const filter = particulerReportAllTransactionCycleRecord.filter((ele)=>ele.toEmployeeId===selectApprover.code)
            console.log('filter :>> ', filter);
            if(filter?.length&&filter[0].isApproved!=="false"){
                setIsDisabledApprover(true)
            }
        }
    }
    console.log('isDisabledApprover :>> ', isDisabledApprover);
    useEffect(() => {
      particulerReportAllTransactionCycleRecord()
    }, [selectApprover])
    const handleClickDisable = () => {
        // Perform your desired action here

        // Set the state to indicate that the button has been clicked
        setButtonClicked(true);
    };

    //get unique emplyee lists
    const getUniqueEmployeeList = async (employeeResponses) => {
        // Grouping by email of employee in the school
        const groupedByEmail = employeeResponses.reduce((acc, obj) => {
            const email = obj.email;
            if (!acc[email]) {
                acc[email] = [];
            }
            acc[email].push(obj);

            return acc;
        }, {});

        console.log(groupedByEmail, "groupedByEmail")
        // Order each group by createdAt date in descending order
        for (const email in groupedByEmail) {
            groupedByEmail[email].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        // Create a list with unique email addresses and the latest object for each email
        const uniqueEmailList = Object.keys(groupedByEmail).map((email) => groupedByEmail[email][0]);

        // Display the result
        console.log(uniqueEmailList, "uniqueEmailList1");
        return uniqueEmailList;
    }

    const checkApplicationAccessibility = () => {
        //six-period
      
        let warCerReqIsSuperadmin = reactLocalStorage.get("isWARCertificatedSuperAdmin");
        setWarCerReqIsSuperadmin(warCerReqIsSuperadmin)
        //-----------------------------------------------------
    };


    //search cognitousers
    /* const setEmpList = async (e, listName) => {
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "name ^= \"" + e.target.value + "\""
            };

            await cognito.listUsers(params, (err, data) => {
                if (err) {
                    //(err.message);
                } else {
                    let usersData = []
                    //let adminUsers = data.Users
                    var role = "";
                    var name = "";
                    var sub = "";
                    var email = "";
                    var usercode = "";

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        name = usercode ? `${name} (${usercode})` : name;
                        let newUser = {
                            "id": sub,
                            "name": name,
                            "email": email,
                            "code": sub,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }

                        usersData.push(newUser)

                        if (i === data.Users.length - 1) {
                            if (listName === 'EMPLOYEE') {
                                setEmployeeList(usersData);
                            }
                            /*  else {
                                let approverRoleList = usersData.filter(item => item.role === USER_TYPES_NAMES.AP);
                                setAllUsersList(usersData)
                            } 
                        }
                        //usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
                    })




                }
            });


        } catch (e) {
            //toast.error(e.message);
        }
    } */

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateInitiatorAndApproverRole()) {
                userHasAuthenticated(false);
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            userHasAuthenticated(false);
        }
    }


    //*onClick Select Period
    const onClickDates = async (date) => {

        setIndexEditMode(false)
        setApply(true)

        if (isNoAbsence) {
            setApply(false)
        }

        if (reportId) {
            //
            if (date.length === 0) {
                setApply(false)
                setSelectedDateRecord(selectedDateFinal);
            }

        } else {
            setSelectedDateRecord([]);
        }



        date = date.sort((a, b) => new Date(a) - new Date(b));

        setIsShowSelectedDate(true)
        let newResponse = [];
        let finald = [...selectedDateFinal]
        let selEmpDate = [];
        let selfinaldate = [...selectedEmpDate]
        let selDate = [];
        let checkSelEmp = [];
        //finald = finald.filter(item => item.hour !== null)
        //for (let k = 0; k < selectedDateRecord.length; k++) {
        //selDate.push(selectedDateRecord[k].selectedDate);
        // if(seldatefinal[k].hour && seldatefinal[k].hour !== null){

        // }
        //}

        let finalMapp = [...mappedData]
        for (let k = 0; k < finalMapp.length; k++) {
            checkSelEmp.push(finalMapp[k].employeeId)
            for (let j = 0; j < finalMapp[k].employeeResponse.length; j++) {
                selDate.push(finalMapp[k].employeeResponse[j].selectedDate);
            }
        }

        // let empName = await DataStore.query(Employee, (c) => c.id.eq(selectedEmployee.code));
        let empName = allEmployeeList.find(o => o.id === selectedEmployee.code)

        if (reportId) {
            for (let i = 0; i < date.length; i++) {
                selEmpDate[i] = date[i]
                if (!selDate.includes(date[i])) {
                    let data = {
                        "employeeName": selectedEmployee?.name,
                        "selectedDate": date[i],
                        "displayDate": date[i],
                        "absentCode": { "name": "", "code": "" },
                        "absentId": "",
                        "employeeType": empName.employeeType,
                        "nameOfTheSubstitute": '',
                        "hour": '',
                        "minute": '',
                        "is_full_day": false,
                    }
                    newResponse.push(data)
                } //else{ selfinaldate = selectedEmpDate.filter(item => item !== date[i])} 


                if (i === date.length - 1) {
                    const newdata = [...finald, ...newResponse]

                    setSelectedDateRecord(newdata)
                }
            }
            let updatedList = [...selfinaldate, ...selEmpDate]
            setSelectedEmpDate(updatedList)

        } else {
            for (let i = 0; i < date.length; i++) {

                let data = { "employeeName": selectedEmployee?.name, "selectedDate": date[i], "displayDate": date[i], "absentCode": { "name": "", "code": "" }, "absentId": "", "employeeType": empName.employeeType, "nameOfTheSubstitute": '', "hour": '', "minute": '', "is_full_day": false }
                newResponse.push(data)
                selEmpDate[i] = date[i]
                if (i === date.length - 1) {
                    setSelectedDateRecord(newResponse)
                }
            }
        }


        if (reportId) {
            const findI = mappedData.findIndex(item => item.employeeId === selectedEmployee.code)
            //allow apply in case of new employee
            let selDataR = [...selectedDateRecord];
            if (findI === -1) {
                setEmployeeWiseMapp(0)
            }
        }


    };

    //*onClick Select Period
    const onClickAbsentCode = (index, event) => {
        let absentCode = event.target.value
        if (reportId) {
            let data = [...mappedData];
            if (data.hasOwnProperty(mapDataIndex)) {
                const indexExists = data[mapDataIndex].employeeResponse.hasOwnProperty(index);
                if (indexExists) {
                    data[mapDataIndex].employeeResponse[index].absentCode = absentCode;
                    data[mapDataIndex].employeeResponse[index].absentId = absentCode.code;
                } else {

                    let data = [...selectedDateRecord];
                    data[index]["absentCode"] = absentCode;
                    data[index]["absentId"] = absentCode.code;
                    setSelectedDateRecord(data)

                    // let obj = {
                    // "absentCode": absentCode,
                    // "absentId": absentCode.code
                    // }
                    // data[mapDataIndex].employeeResponse.push(obj)
                }
            } else {
                let data = [...selectedDateRecord];
                data[index]["absentCode"] = absentCode;
                data[index]["absentId"] = absentCode.code;
                setSelectedDateRecord(data)

            }

            setMappedData(data)
        } else {
            let data = [...selectedDateRecord];
            data[index]["absentCode"] = absentCode;
            data[index]["absentId"] = absentCode.code;
            setSelectedDateRecord(data)
        }
    };

    //*onClick Select Period
    const onClickNameOfSubstitute = (index, event) => {

        if (reportId) {
            let nameOfTheSubstitute = event.target.value
            let data = [...mappedData];

            if (data.hasOwnProperty(mapDataIndex)) {
                let empResponse = data[mapDataIndex].employeeResponse
                const indexExists = data[mapDataIndex].employeeResponse.hasOwnProperty(index);
                if (indexExists) {
                    data[mapDataIndex].employeeResponse[index]["nameOfTheSubstitute"] = { name: nameOfTheSubstitute, code: null };
                    data[mapDataIndex].employeeResponse[index]["nameOfTheSubstituteId"] = null;
                } else {
                    let nameOfTheSubstitute = event.target.value
                    let data = [...selectedDateRecord];
                    data[index]["nameOfTheSubstitute"] = { name: nameOfTheSubstitute, code: null };
                    data[index]["nameOfTheSubstituteId"] = absentCode.code;
                    setSelectedDateRecord(data)
                }

            } else {

                let nameOfTheSubstitute = event.target.value
                let data = [...selectedDateRecord];
                data[index]["nameOfTheSubstitute"] = { name: nameOfTheSubstitute, code: null };
                data[index]["nameOfTheSubstituteId"] = absentCode.code;
                setSelectedDateRecord(data)
            }
            setMappedData(data)

        } else {

            let nameOfTheSubstitute = event.target.value
            let data = [...selectedDateRecord];
            data[index]["nameOfTheSubstitute"] = { name: nameOfTheSubstitute, code: null };
            data[index]["nameOfTheSubstituteId"] = absentCode.code;
            setSelectedDateRecord(data)


        }

    };

    //*onClick Houre
    const onClickHoure = (index, value) => {
        value = value === null ? 0 : value;
        if (reportId) {
            let data = [...mappedData];
            if (data.hasOwnProperty(mapDataIndex)) {
                const indexExists = data[mapDataIndex].employeeResponse.hasOwnProperty(index);
                if (indexExists) {
                    data[mapDataIndex].employeeResponse[index]["hour"] = value;
                } else {
                    let data = [...selectedDateRecord];
                    data[index]["hour"] = value;
                    setSelectedDateRecord(data)
                }
                setMappedData(data)

            } else {

                let data = [...selectedDateRecord];
                data[index]["hour"] = value;
                setSelectedDateRecord(data)
            }

        } else {
            let data = [...selectedDateRecord];
            data[index]["hour"] = value;
            setSelectedDateRecord(data)
        }
    };

    //*onClick Min
    const onClickMin = (index, value) => {
        value = value === null ? 0 : value;
        if (reportId) {
            let data = [...mappedData];

            if (data.hasOwnProperty(mapDataIndex)) {
                const indexExists = data[mapDataIndex].employeeResponse.hasOwnProperty(index);
                if (indexExists) {
                    data[mapDataIndex].employeeResponse[index]["minute"] = value;
                } else {
                    let data = [...selectedDateRecord];
                    data[index]["minute"] = value;
                    setSelectedDateRecord(data)
                }
                setMappedData(data)

            } else {
                let data = [...selectedDateRecord];
                data[index]["minute"] = value;
                setSelectedDateRecord(data)
            }

        } else {
            let data = [...selectedDateRecord];
            data[index]["minute"] = value;
            setSelectedDateRecord(data)
        }
    };



    const setFlagToFullDay = (index, e) => {
        let checked = e.target.checked;

        if (reportId) {
            let data = [...mappedData];

            if (data.hasOwnProperty(mapDataIndex)) {
                const indexExists = data[mapDataIndex].employeeResponse.hasOwnProperty(index);
                if (indexExists) {
                    data[mapDataIndex].employeeResponse[index]["is_full_day"] = checked;
                } else {
                    let data = [...selectedDateRecord];
                    data[index]["is_full_day"] = checked;
                    setSelectedDateRecord(data)
                }
                setMappedData(data)

            } else {
                let data = [...selectedDateRecord];
                data[index]["is_full_day"] = checked;
                setSelectedDateRecord(data)
            }

        } else {
            let data = [...selectedDateRecord];
            data[index]["is_full_day"] = checked;
            setSelectedDateRecord(data)
        }

        if (e.target.checked) {
            onClickHoure(index, 0)
            onClickMin(index, 0)
        }


    }

    const [selectedName, setSelectedName] = useState([]);

    const [selectedItem, setSelectedItem] = useState([]);
    console.log("selected date indexEditMode",indexEditMode);
console.log("selected date selectedItem",selectedItem);

    const [selectedDateRecordNew, setSelectedDateRecordNew] = useState([]);

    const onClickUpdateFollow = (i, item) => {
        setAbsentDate([]);
        let index = mappedData.findIndex(item1 => item1.employeeId === item.employeeId)
        setMapDataIndex(index)
        item.employeeResponse.map((detail, detailIndex) => (
            (i === 0 || i > 0) ? onClickUpdate(i, detailIndex, detail, item) : null
        ))
        //onClickUpdate()
    }


    //Roving substitute
    async function loadRovingUsers() {

        try {

            var employeeRoving = await graphQLGetAllData("listEmployees", [{ email: { eq: rovingSubstituteEmail } }])
            if (employeeRoving.length) {
                let name = employeeRoving[0].employee_code ? `${employeeRoving[0].employee_name} (${employeeRoving[0].employee_code})` : employeeRoving[0].employee_name;
                let obj = {
                    name: name,
                    code: employeeRoving[0].id
                }
                //setRovingSubstitute(obj);
                return obj;
            }

        } catch (e) {
        }
    }


    const SaveUserToCognito = async (newEmployeeId) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        const userPoolId = awsmobile.aws_user_pools_id;
        const username = NewEmployeeEmail
        const password = "Gusd@2023"
        const Permanent = true

        let attributes = [
            {
                Name: 'email',
                Value: NewEmployeeEmail
            },
            {
                Name: 'custom:firstName',
                Value: newEmpFirstName
            },
            {
                Name: 'custom:lastName',
                Value: capitalizeFirstChar(newEmpLastName)
            },
            {
                Name: 'name',
                // Value: NewEmployeeName
                Value: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase()
            },
            {
                Name: 'custom:userCode',
                Value: NewEmployeeCode
            },
            // {
            //     Name: 'custom:city',
            //     Value: city
            // },
            // {
            //     Name: 'custom:mobileNumber',
            //     Value: phoneNo
            // },
            // {
            //     Name: 'custom:address',
            //     Value: addressOne
            // },
            // {
            //     Name: 'custom:stateId',
            //     Value: state
            // },
            // {
            //     Name: 'custom:countryId',
            //     Value: country
            // },
            // {
            //     Name: 'custom:userType',
            //     Value: userType.label
            // },
            {
                Name: 'custom:empId',
                Value: newEmployeeId
            },

        ];

        const params = {
            UserPoolId: userPoolId,
            Username: username,
            UserAttributes: attributes
        };

        const params2 = {
            UserPoolId: userPoolId,
            Username: username,
            Password: password,
            Permanent: Permanent,
        };

        let userSub;
        try {
            const createUserResponse = await cognito.adminCreateUser(params).promise();
            console.log('Employee confirmed and saved successfully', createUserResponse);
            userSub = createUserResponse.User?.Attributes?.find(attr => attr.Name === 'sub')?.Value;
            // setUserSub(userSub);
            // toast.success("Employee confirmed and saved successfully")

            // User Confirmation 
            cognito.adminSetUserPassword(params2, (err, data) => {
                if (err) {
                    console.log('Error confirming user:', err);
                } else {
                    console.log('User confirmed successfully:', data);
                }
            });

        } catch (error) {
            toast.error("Employee already exist.")
            setOpenNewEmployee(false)
            setNewEmployeeSchool(null);
            // setNewEmployeeName("");
            setNewEmpFirstName("");
            setNewEmpLastName("");
            setNewEmpSelectedRole(null);
            setNewEmpSelectedDesignation(null);

            setNewEmployeeCode("");
            setNewEmployeeEmail("");
            console.error('Error saving Cognito user:', error);
        }



        if (userSub !== null) {
            //Update Employee with Cognito UserId
            const original = await API.graphql(
                graphqlOperation(queries.getEmployee,
                    { id: newEmployeeId }
                )
            );
            // await DataStore.query(Employee, newEmployeeId);
            await API.graphql(
                graphqlOperation(mutations.updateEmployee, {
                    input: {
                        id: original?.data?.getEmployee?.id,
                        user_Id: userSub,
                        _version: original?.data?.getEmployee?._version,
                    }
                }))
            // await DataStore.save(
            //     Employee.copyOf(original, (updated) => {
            //         updated.user_Id = userSub
            //     })
            // );
            // const original = await DataStore.query(Employee, newEmployeeId);
            // const original = await graphQLFindRecordById("getEmployee", newEmployeeId)

            // // Update record
            // await API.graphql({
            //     query: mutations.updateEmployee,
            //     variables: {
            //         input: {
            //             id: original.id,
            //             _version: original._version,
            //             user_Id: userSub
            //         }
            //     }
            // });

            /* await DataStore.save(
                Employee.copyOf(original, (updated) => {
                    updated.user_Id = userSub
                })
            ); */

        }


    }

    const AddNewEmployee = async () => {
        if (selectedSchool === "" || selectedSchool === null) {
            toast.error("Please Select School/Department");
            return;
        }
        // else if (NewEmployeeName === null || NewEmployeeName === "") {
        //     toast.error("Please Enter Employee Name");
        //     return;
        // } 
        else if (newEmpFirstName === null || newEmpFirstName === "") {
            toast.error("Please Enter Employee First Name");
            return;
        }
        else if (newEmpLastName === null || newEmpLastName === "") {
            toast.error("Please Enter Employee Last Name");
            return;
        }
        // else if (newEmpSelectedRole === null) {
        //     toast.error("Please Select Employee Role");
        //     return;
        // }
        // else if (newEmpSelectedDesignation === null) {
        //     toast.error("Please Select Employee Designation");
        //     return;
        // }

        else if (NewEmployeeCode === "") {
            toast.error("Please Enter Employee Code");
            return;
        } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
            toast.error("Please Enter Employee Email");
            return;
        } else if (employeeTypeField === null || employeeTypeField === "") {
            toast.error("Please Enter Employee Type");
            return;
        }

        // var AddedNewEmployee = await DataStore.save(new Employee(
        //     {
        //         "school_id": selectedSchool?.code,
        //         "employee_name": NewEmployeeName,
        //         "employee_code": NewEmployeeCode,
        //         "email": NewEmployeeEmail,
        //         "employeeType": employeeTypeField ? employeeTypeField.code : employeeTypeField

        //     }
        // ))

        //const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
        //first check typed email id is already present or not Query updated for school
        // const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } },{ school_id: { eq: selectedSchool?.code } }])
        // console.log(matchedEmailRecord.length,"matchedEmailRecord.length")

        const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
        console.log(matchedEmailRecord.length, "matchedEmailRecord.length")
        const matchedEmailSchool = matchedEmailRecord.filter(item => item.school_id === selectedSchool?.code)
        console.log(matchedEmailSchool.length, "matchedEmailSchool.length")

        if (matchedEmailSchool.length == 0) {

            var AddedNewEmployee = await API.graphql(
                graphqlOperation(mutations.createEmployee, {
                    input: {
                        school_id: selectedSchool?.code,

                        firstName: newEmpFirstName.toUpperCase(),
                        lastName: capitalizeFirstChar(newEmpLastName),
                        employee_name: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase(),
                        // role: newEmpSelectedRole?.code,
                        // designation: newEmpSelectedDesignation.code,

                        // employee_name: NewEmployeeName,
                        employee_code: NewEmployeeCode,
                        email: NewEmployeeEmail,
                        employeeType: employeeTypeField ? employeeTypeField.code : employeeTypeField
                    }
                })
            );
            getMasterData();

            if (AddedNewEmployee?.data?.createEmployee?.id !== null) {
                if (matchedEmailRecord.length === 0) {
                    //Save Cognito User
                    await SaveUserToCognito(AddedNewEmployee?.data?.createEmployee?.id);
                }
            }

            toast.success('Data Added Successfully.');
            try {
                // var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(AddedNewEmployee?.school_id),
                //     {
                //         sort: s => s.employee_name(SortDirection.ASCENDING),
                //     }
                // );
                var employeeResponses = await fetchPaginatedRecords(
                    queries.listEmployees,
                    { school_id: { eq: AddedNewEmployee?.data?.createEmployee?.school_id } },
                    { field: "employee_name", direction: "asc" },
                    3000,
                    'listEmployees'
                );
                console.log('employeeResponses --->', employeeResponses);
                // console.log('allEmployeeList --->', allEmployeeList);
                // var employeeResponses = allEmployeeList.filter(e => e.school_id !== null && e.school_id.includes(AddedNewEmployee.data.createEmployee.school_id))
                // employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

                if (employeeResponses !== null) {
                    let employeeData = employeeResponses;
                    employeeData = await getUniqueEmployeeList(employeeData)

                    let employee = [{ name: "No Absence", code: "1" }];

                    //push roving substitute
                    let rovingSubstituteuser = await loadRovingUsers();
                    console.log(rovingSubstituteuser, "rovingSubstituteuser")
                    if (rovingSubstituteuser) {
                        employee.push(rovingSubstituteuser)
                    }

                    employeeData.map((item) => {
                        if (item.employeeType === 'Certificated' || item.employeeType === 'Administrator') {
                            let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                            let obj = {
                                name: name,
                                code: item.id
                            }
                            employee.push(obj);
                        }
                    })

                    setEmployeeList(employee);
                }
            }
            catch (error) { }

            let obj = {
                name: (AddedNewEmployee.data.createEmployee.employee_name + ' ' + '(' + AddedNewEmployee.data.createEmployee.employee_code + ')'),
                code: AddedNewEmployee.data.createEmployee.id
            }



            setSelectedEmployee(obj);
            setOpenNewEmployee(false)
            setNewEmployeeSchool(null);
            // setNewEmployeeName("");
            setNewEmpFirstName("");
            setNewEmpLastName("");
            setNewEmpSelectedRole(null);
            setNewEmpSelectedDesignation(null);
            setNewEmployeeCode("");
            setNewEmployeeEmail("");

            // onSetEmployee(obj); setAbsentDate([])
        } else {
            toast.error("Please Use Another Email");
        }

    }
    const onClickUpdate = async (index, detailIndex, detail, item) => {
        
        setIndexEditMode(true)
        setSelectedDateRecordNew([])
        setSelectedItem(detail.selectedDate);

        if (item) {
            getDataOnChange(item.employeeId)
            setSelectedName(item.employeeName)
            // let empName = await DataStore.query(Employee, (c) => c.id.eq(item.employeeId));
            let empName = allEmployeeList.find(o => o.id === item.employeeId)


            if (empName) {
                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name
                let obj1 = {
                    "name": name,
                    "code": empName.id
                }
                setSelectedEmployee(obj1);
            }
        }

        setApply(false)

        //setMappcount
        let innerArrayLength = 0;
        let mapArry = mappedData.filter(item => item.employeeId === selectedEmployee.code)
        for (var key in mapArry) {
            innerArrayLength = innerArrayLength + mapArry[key].employeeResponse.length
        }
        setEmployeeWiseMapp(innerArrayLength)

        let data = [...mappedData];
        let selData = [...selectedDateRecord];
        if (!indexEditMode) {
            //data= data[index].employeeResponse.filter((item, i) =>  i=== detailIndex  )
            selData = selData.length ? selData.filter((item, i) => i === index) : ''
        }
        setIndexEdit(index)
        setDetailIndexEdit(detailIndex)
        let a = '';
        selectedDateRecord.map((currentItem, i) => {
            a = (indexEditMode && selectedItem === currentItem.displayDate) ?
                currentItem : ''
        });
    }

    //onclick remove container details
    const onClickRemove = (index, detailIndex, detail, item) => {
        let data = [...mappedData];
        let selData = [...selectedDateRecord];
        setIndexEditMode(false)

        setSelectedDateRecordNew([])
        //set disabledates

        var indexofdate = disabledDates.indexOf(detail.selectedDate);
        let newDates = disabledDates.splice(indexofdate);
        let updateDate = []
        if (disabledDates[item.employeeId] && disabledDates[item.employeeId].length) {
            let newDisabele = disabledDates[item.employeeId].filter(item => item !== detail.selectedDate)
            for (var key in disabledDates) {
                if (key === item.employeeId) {
                    //newDisabele = disabledDates[item.employeeId].filter(item => item !== detail.selectedDate)
                    newDisabele[key] = disabledDates[item.employeeId].filter(item => item !== detail.selectedDate)
                } else {
                    newDisabele[key] = disabledDates[key]
                }
            }

            updateDate = newDisabele
        }

        setDisabledDates(updateDate)

        if (data[index].employeeResponse.length === 1) {
            data.splice(index, 1)
            setMappedData(data)
            selData.splice(index, 1)
            setSelectedDateRecord(selData)

        } else {
            data[index].employeeResponse.splice(detailIndex, 1)
            setMappedData(data)
            selData.splice(index, 1)
            setSelectedDateRecord(selData)
        }

        //change when employee delete and selected
        if (reportId) {
            if (updateDate.length === 0) {
                //getDataOnChange(selectedEmployee.code)
                setSelectedDateRecord([])

            }
        }

    }

    const currentDateTime = moment();

    async function UserList(e) {
        try {
            // var employeeResponses = await DataStore.query(Employee, (c) => c.role.eq(USER_TYPES.APPROVER),
            //     {
            //         sort: s => s.employee_name(SortDirection.ASCENDING),
            //     }
            // );

            var employeeResponses = allEmployeeList.filter(e => e.role && e.role.includes(USER_TYPES.APPROVER))
            employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

            if (employeeResponses !== null) {
                let employeeData = employeeResponses.filter(item => item._deleted !== true);
                employeeData = removeDuplicateApprover(employeeData);


                let employee = [];
                employeeData.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id
                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
                    setAllApproverList(employee)
                } else {
                    setAllApproverList(employee)
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    async function LoadUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60
            };

            ///fetch users
            try {
                const data = await cognito.listUsers(params).promise();

                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                data.Users.forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );

                let usersWithoutAdmin = [];
                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin') {
                        usersWithoutAdmin.push(currentItem);
                    }
                })
                setSPUsersWithoutAdmin(usersWithoutAdmin);

            } catch (err) {
                console.log(err);
            }
            //-------------

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    console.log(err);
                    toast.error(err.message);
                } else {

                    const roles = [];
                    var newRes = []
                    var role = "";
                    var name = "";
                    var sub = "";
                    var email = "";
                    var usercode = "";
                    let withoutAdminUsers = [];
                    let payrollUser = []

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        let newUser = {
                            "userId": sub,
                            "name": name,
                            "email": email,
                            "usercode": usercode,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }
                        newRes.push(newUser);

                        if (i === data.Users.length - 1) {

                            for (let i = 0; i < newRes.length; i++) {
                                const user = newRes[i];
                                const roleIndex = roles.findIndex(role => role.role === user.role);


                                if (roleIndex === -1) {
                                    roles.push({ role: user.role, count: 1, users: [user], email: user.email, name: user.name, usercode: user.usercode });
                                } else {
                                    roles[roleIndex].count++;
                                    roles[roleIndex].users.push(user);
                                }
                            }
                        }

                        if (role === USER_TYPES.APPROVER) {
                            let userObj = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            withoutAdminUsers.push(userObj);
                        }

                        if (role === USER_TYPES.PAYROLL) {
                            let userObjs = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            payrollUser.push(userObjs);
                        }
                    });

                    let sortArray = newRes.sort((a, b) => (a.name > b.name ? 1 : -1))

                    var userList = sortArray.map((currentItem) => {
                        let name = currentItem.usercode ? `${currentItem.name} (${currentItem.usercode})` : currentItem.name;
                        return (
                            { code: currentItem.userId, name: name }
                        )
                    })

                    const matchedItem = newRes.find(item => item.userId === loggedl1authority);
                    if (matchedItem) {
                        let newname = matchedItem.usercode ? `${matchedItem.name} (${matchedItem.usercode})` : matchedItem.name;
                        if (!reportId) {
                            // setSelectApprover({ name: newname, code: matchedItem?.userId });
                            // setAllApproverList([{ name: newname, code: matchedItem?.userId }])
                        }
                    } else {
                        if (!reportId) {
                            setSelectApprover({});
                        }
                    }

                    if (!reportId) {
                        UserList();
                        // setAllUsersList(userList)
                    }
                    SetUsersList(roles);
                    setPayrollUserList(payrollUser);
                    Setl1UserList(withoutAdminUsers);

                }
            });

        } catch (e) {
            toast.error(e.message);
        }
    }

    async function EmployeeList(e) {
        let schoolId = e.value.code;
        setSelectedSchool(e.value)
        try {
            // var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(schoolId),
            //     {
            //         sort: s => s.employee_name(SortDirection.ASCENDING),
            //     }
            // );

            var employeeResponses = allEmployeeList.filter(e => e.school_id && e.school_id.includes(schoolId))

            employeeResponses = employeeResponses.filter(e => e._deleted !== true)

            employeeResponses = await getUniqueEmployeeList(employeeResponses);
            employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

            console.log("allEmployeeList", allEmployeeList)
            console.log("schoolId", schoolId)
            console.log("employeeResponses", employeeResponses)

            if (employeeResponses !== null) {
                let employeeData = employeeResponses;
                employeeData = removeDuplicateApprover(employeeData);


                let filteredTypeData = employeeData.filter(item => {
                    const employeeType = item.employeeType;
                    return employeeType === "Certificated" || employeeType === "Administrator";
                });

                let employee = [{ name: "No Absence", code: "1" }];
                //push roving substitute
                let rovingSubstituteuser = await loadRovingUsers();
                console.log(rovingSubstituteuser, "rovingSubstituteuser")
                if (rovingSubstituteuser) {
                    employee.push(rovingSubstituteuser)
                }
                filteredTypeData.map((item) => {
                    if (item.employeeType === 'Certificated' || item.employeeType === 'Administrator') {
                        let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                        let obj = {
                            name: name,
                            code: item.id
                        }
                        employee.push(obj);
                    }

                })
                setEmployeeList(employee);

            }
        }
        catch (error) {

            console.log(error)
        }
    }


    async function BindList() {

        if (reportId) {
            getData()
        }
    }

    //*get Existing Data
    const getData = async () => {
        if (reportId) {
            setVisible(true);

            if(type!=="copyReport"){
                if(type ==="SAEdit"){
                    setDisabled(false);
                }else{
                setDisabled(true);
                }
            }

            let updateData = []
            // var getAbsenceReport = await DataStore.query(CertificatedAdminWeeklyAbsenceReport, reportId)
            var getAbsenceReport = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)
            console.log('getAbsenceReport :>> ', getAbsenceReport);

            if (getAbsenceReport) {
                if (getAbsenceReport.l1_authority) {
                    // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(getAbsenceReport.l1_authority));
                    let empName = allEmployeeList.filter(e => e.user_Id && e.user_Id.includes(getAbsenceReport.l1_authority))

                    let name = empName[0].employee_code ? `${empName[0].employee_name} (${empName[0].employee_code})` : empName[0].employee_name;

                    let objFirst = { name: name, code: getAbsenceReport.l1_authority }
                    console.log('objFirst :>> ', objFirst);
                    setSelectApprover(objFirst)
                }

                //check particular report status start
                if (getAbsenceReport.status === 'OPEN') {
                    //means its pending then we want to show =>save button there.
                    setIsPendingRequest(true);
                }
                //check particular report status end

                // let to_date = new Date(moment(getAbsenceReport.to_date).format("YYYY-MM-DD"));
                // let from_date = new Date(moment(getAbsenceReport.from_date).format("YYYY-MM-DD"));

                let to_date = new Date(moment(getAbsenceReport.to_date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
                let from_date = new Date(moment(getAbsenceReport.from_date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));


                setApproverStatus(getAbsenceReport.approver_status)
                let dateArray = [from_date, to_date]; setPeriodDates(dateArray);
                if(type==="copyReport"){setOldPeriodDates(dateArray)}
                
                // var getAbsenceReportOfEmployee = await DataStore.query(Schools, (c) => c.id.eq(getAbsenceReport.school_id))
                var getAbsenceReportOfEmployee = await graphQLFindRecordById("getSchools", getAbsenceReport.school_id)

                setSelectedSchool({ name: getAbsenceReportOfEmployee.name, code: getAbsenceReportOfEmployee.id })
                // var employeeResponses = await DataStore.query(Employee,
                //     (c) => c.school_id.eq(getAbsenceReport.school_id),
                //     Predicates.ALL, { sort: s => s.employee_name(SortDirection.ASCENDING) }
                // );

                var employeeResponses = allEmployeeList.filter(e => e.school_id && e.school_id.includes(getAbsenceReport.school_id));
                employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

                if (employeeResponses !== null) {
                    let employeeData = employeeResponses;
                    let employee = [{ name: "No Absence", code: "1" }];
                    //push roving substitute
                    let rovingSubstituteuser = await loadRovingUsers();
                    console.log(rovingSubstituteuser, "rovingSubstituteuser")
                    if (rovingSubstituteuser) {
                        employee.push(rovingSubstituteuser)
                    }
                    employeeData.map((item) => {
                        if (item.employeeType == 'Administrator' || item.employeeType == 'Administratoristrator' || item.employeeType == 'Admin' || item.employeeType == 'Certificated') {
                            let obj = {
                                name: (item.employee_name + ' ' + '(' + item.employee_code + ')'),
                                code: item.id
                            }
                            employee.push(obj);
                        }
                    })
                    setEmployeeList(employee);
                }
            }

            if (getAbsenceReport) {
                // var getAbsenceReportOfEmployee = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(getAbsenceReport.id))

                var getAbsenceReportOfEmployee = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: getAbsenceReport.id } }])

                let newResponse = [];
                let dataRec = [];
                let checkEmployee = [];
                let selectdate = []
                let newEmp = '';

                // getAbsenceReportOfEmployee = getAbsenceReportOfEmployee.sort((a, b) => {
                // const idA = a.employee_id;
                // const idB = b.employee_id;
                // if (idA < idB) {
                // return -1;
                // }
                // if (idA > idB) {
                // return 1;
                // }
                // return 0;
                // })

                // const uniqueValues = [ ...new Set(getAbsenceReportOfEmployee.map(item => item.employeeId)) ];
                // const uniqueDataArray = Array.from(uniqueValues);

                let remarkNew = ''
                let statusNew = ''
                if (getAbsenceReport.payroll_status !== null && getAbsenceReport.payroll_status === CertificatedAdminWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
                    statusNew = "Approved"; remarkNew = "";
                } else if (getAbsenceReport.payroll_status !== null && getAbsenceReport.payroll_status === CertificatedAdminWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
                    statusNew = "Rejected"; remarkNew = getAbsenceReport.payroll_remark;
                } else if (getAbsenceReport.approver_status !== null && getAbsenceReport.approver_status === CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {
                    statusNew = "Approved"; remarkNew = "";
                } else if (getAbsenceReport.approver_status !== null && getAbsenceReport.approver_status === CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_REJECTED) {
                    statusNew = "Rejected"; remarkNew = getAbsenceReport.approver_remark;
                } else if (getAbsenceReport.payroll_status === null && getAbsenceReport.approver_status === null && getAbsenceReport.status === CertificatedAdminWeeklyAbsenceReportStatus.SUBMITTED) {
                    statusNew = "Submitted"; remarkNew = "";
                } else if (getAbsenceReport.payroll_status === null && getAbsenceReport.approver_status === null && getAbsenceReport.status === CertificatedAdminWeeklyAbsenceReportStatus.OPEN) {
                    statusNew = "Pending"; remarkNew = "";
                }

                if(type!=="copyReport"){
                setStatus(statusNew)
                }
                setRemark(remarkNew)
                setComment(getAbsenceReport.comment)

                if (getAbsenceReportOfEmployee.length === 0) {
                    setSelectedEmployee({ name: "No Absence", code: "1" })
                    setIsNoAbsence(true)
                }
                else {
                    setIsNoAbsence(false)
                }


                for (var i = 0; i < getAbsenceReportOfEmployee.length; i++) {

                    let employeeResponse = await getEmployeeDetails(getAbsenceReportOfEmployee[i].id, getAbsenceReportOfEmployee[i].employee_id);


                    employeeResponse.map((item) => item.selectedDate = new Date(moment(item.selectedDate).format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")))

                    //employeeResponse.map((item) =>setSelectedEmpDate([item.selectedDate]))
                    //employeeResponse.map((item) => selEmpDate[i] = item.selectedDate )
                    //order date by selected date
                    employeeResponse = [...employeeResponse].sort((a, b) => new Date(a.selectedDate) - new Date(b.selectedDate));

                    for (let s = 0; s < employeeResponse.length; s++) {
                        if (employeeResponse[s].minute === null || employeeResponse[s].minute === "Nan") {
                            employeeResponse[s].minute = 0
                        }
                    }

                    // let empName = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployee[i].employee_id));
                    let empName = allEmployeeList.find(o => o.id === getAbsenceReportOfEmployee[i].employee_id)

                    //dataRec[i] = {employeeName:'', selectedDate: selEmpDate[i], displayDate: selEmpDate[i], absentCode: '', absentId: '', nameOfTheSubstitute: '', hour: '', minute:'',}

                    if (!checkEmployee.includes(empName.id)) {
                        checkEmployee[i] = getAbsenceReportOfEmployee[i].employee_id
                    }

                    let data = []
                    if (empName) {
                        let obj1 = {
                            "name": empName.employee_code ? (empName.employee_name + ' ' + '(' + empName.employee_code + ')') : (empName.employee_name),
                            "code": empName.id
                        }

                        //employeeListdata[i] = obj1
                        setSelectedEmployee(obj1);
                        newEmp = empName.id;

                        //added for employee selected date
                        // if(checkEmployee.includes(empName[0].id)){
                        // employeeResponse.map((item) => selEmpDate[i] = item.selectedDate )
                        // }
                    }
                    data = {
                        "employeeName": empName.employee_name,
                        "employeeId": getAbsenceReportOfEmployee[i].employee_id,
                        "employeeResponse": employeeResponse,
                        "employeeType": getAbsenceReportOfEmployee[i].employee_type,
                    }
                    let updatedate = [];
                    dataRec = []

                    // for(var k=0; k< employeeResponse.length; k++ ){
                    // dataRec[k] = employeeResponse[k]
                    // dataRec[k].nameOfTheSubstitute =  dataRec[k].nameOfTheSubstitute.name ? {"name":dataRec[k].nameOfTheSubstitute.name ,"code": dataRec[k].nameOfTheSubstitute.code} : dataRec[k].nameOfTheSubstitute
                    //updateEmpList.push({"name":dataRec[k].nameOfTheSubstitute.name ,"code": dataRec[k].nameOfTheSubstitute.code})
                    // setSelectedItem(employeeResponse[k].selectedDate)
                    // selectdate.push(employeeResponse[k].selectedDate)
                    // updatedate[k] = employeeResponse[k].selectedDate
                    // empmr = [...empmr,...dataRec]
                    // getDt[dataRec[k].employeeName] = dataRec 
                    // }	


                    if (newResponse.length > 0) {
                        newResponse = [...newResponse, data];
                    } else {
                        newResponse.push(data)
                    }

                    let newdate = [];
                    if (i === getAbsenceReportOfEmployee.length - 1) {
                        const groupedData = newResponse.reduce((acc, obj) => {
                            const existingObj = acc.find(item => item.employeeId === obj.employeeId);
                            if (existingObj) { existingObj.employeeResponse.push(...obj.employeeResponse); }
                            else { acc.push(obj); }
                            return acc;
                        }, []);

                        let newR = newResponse.filter(abc => abc.employeeId === getAbsenceReportOfEmployee[i].employee_id)
                        let countR = 0
                        for (let key in newR) {
                            if (newR[key] && newR[key].employeeResponse) {
                                for (var k = 0; k < newR[key].employeeResponse.length; k++) {
                                    newR[key].employeeResponse[k].minute = isNaN(newR[key].employeeResponse[k].minute) ? 0 : newR[key].employeeResponse[k].minute;
                                    dataRec[countR] = newR[key].employeeResponse[k]
                                    dataRec[countR].nameOfTheSubstitute = dataRec[countR].nameOfTheSubstitute.name ? { "name": dataRec[countR].nameOfTheSubstitute.name, "code": dataRec[countR].nameOfTheSubstitute.code } : dataRec[countR].nameOfTheSubstitute
                                    setSelectedItem(newR[key].employeeResponse[k].selectedDate)
                                    selectdate.push(newR[key].employeeResponse[k].selectedDate)
                                    updatedate[countR] = newR[key].employeeResponse[k].selectedDate
                                    //updName[countR] = newR[key].employeeResponse[k].employeeName
                                    setSelectedName(newR[key].employeeResponse[k].employeeName)
                                    countR = countR + 1
                                }
                            }
                        }

                        const sortedArray = groupedData.slice().sort((a, b) => {
                            const nameA = a.employeeName.toLowerCase();
                            const nameB = b.employeeName.toLowerCase();
                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            return 0;
                        });

                        let administratorData = sortedArray.filter(item => item.employee_type === 'Administrator');
                        let certificatedData = sortedArray.filter(item => item.employee_type === 'Certificated');

                        setAdministratorData(administratorData)
                        setCertificatedDatas(certificatedData)
                        setMappedData(sortedArray)
                        // setSelectedDateRecord(dataRec)
                        setMapDataIndex(newResponse.length - 1)
                        setSelectedDateFinal(dataRec)
                        setSelectedDateRecordNew(dataRec)
                        if (newEmp) { newdate[newEmp] = updatedate }
                        setDisabledDates(newdate)
                        setVisible(true);
                    }
                }

                let updatedList = [...selectedEmpDate, ...selectdate]
                setSelectedEmpDate(updatedList)
            }
        }
    }

    //*All state clear
    const getEmployeeDetails = async (employeeDetailId, employeeId) => {

        let newResponse = [];
        // var getAbsenceReportOfEmployeeDetails = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployeeDetails, (c) => c.Certificated_Admin_Weekly_Absence_Report_Employee_id.eq(employeeDetailId))

        var getAbsenceReportOfEmployeeDetails = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: employeeDetailId } }])



        for (var i = 0; i < getAbsenceReportOfEmployeeDetails.length; i++) {

            let employeeName = ""; let substituteEmployeeName = "";
            // let empResponse = await DataStore.query(Employee, (c) => c.id.eq(employeeId));
            let empResponse = allEmployeeList.find(o => o.id === employeeId)

            if (empResponse) { employeeName = empResponse.employee_name } else { employeeName = "" }
            // let substituteResponse = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].substitute_emp_id))
            let substituteResponse = allEmployeeList.find(o => o.id === getAbsenceReportOfEmployeeDetails[i].substitute_emp_id)

            if (substituteResponse) { substituteEmployeeName = substituteResponse.employee_name; } else { substituteResponse = ""; substituteEmployeeName = getAbsenceReportOfEmployeeDetails[i].substitute_emp_id }
            // var getAbsentCodeDetails = await DataStore.query(AbsentCode, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].absent_code_id))
            var getAbsentCodeDetails = absentCodeList.find(o => o.id === getAbsenceReportOfEmployeeDetails[i].absent_code_id)

            let getAbsentCodeObj;
            if (getAbsentCodeDetails) { getAbsentCodeObj = { "name": getAbsentCodeDetails.name + " (" + getAbsentCodeDetails.code + ")", "code": getAbsentCodeDetails.id } } else { getAbsentCodeObj = { "name": "", "code": "" } }

            newResponse.push({
                "employeeName": employeeName,
                "selectedDate": getAbsenceReportOfEmployeeDetails[i].absent_date,
                "displayDate": getAbsenceReportOfEmployeeDetails[i].absent_date,
                "absentCode": getAbsentCodeObj,
                "absentId": getAbsenceReportOfEmployeeDetails[i].absent_code_id,
                "nameOfTheSubstitute": { "name": substituteEmployeeName, "code": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id }, "nameOfTheSubstituteId": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id, "hour": getAbsenceReportOfEmployeeDetails[i].partial_hour,
                "minute": getAbsenceReportOfEmployeeDetails[i].partial_min,
                "is_full_day": getAbsenceReportOfEmployeeDetails[i].is_full_day,
                "employeeType": getAbsenceReportOfEmployeeDetails[i].employee_type
            })

            if (i === getAbsenceReportOfEmployeeDetails.length - 1) {
                return newResponse
            }
        }
    };

    //get onchange
    const getDataOnChange = async (empid) => {
        if (reportId) {
            setVisible(true)
            if(type !=="copyReport"){
                if(type ==="SAEdit"){
            setDisabled(false);
                }else{
            setDisabled(true);
                }
            }

            let updateData = []
            // var getAbsenceReport = await DataStore.query(CertificatedAdminWeeklyAbsenceReport, reportId)

            var getAbsenceReport = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)

            if (getAbsenceReport) {
                // let to_date = new Date(moment(getAbsenceReport.to_date).format("YYYY-MM-DD"));
                // let from_date = new Date(moment(getAbsenceReport.from_date).format("YYYY-MM-DD"));

                let to_date = new Date(moment(getAbsenceReport.to_date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
                let from_date = new Date(moment(getAbsenceReport.from_date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));

                let dateArray = [from_date, to_date];
                if(type!=="copyReport"){
                    if(type !=="SAEdit"){
                setPeriodDates(dateArray);
                    }
                }
                // var getAbsenceReportOfEmployee = await DataStore.query(Schools, (c) => c.id.eq(getAbsenceReport.school_id))

                var getAbsenceReportOfEmployee = allSchoolList.find(o => o.id === getAbsenceReport.school_id)

                if(type!=="copyReport"){
                    if(type !=="SAEdit"){
                setSelectedSchool({ name: getAbsenceReportOfEmployee.name, code: getAbsenceReportOfEmployee.id })
                    }
                }
                // var employeeResponses = await DataStore.query(Employee,
                //     (c) => c.school_id.eq(getAbsenceReport.school_id),
                //     Predicates.ALL, { sort: s => s.employee_name(SortDirection.ASCENDING) }
                // );
                var employeeResponses = allEmployeeList.filter(e => e.school_id && e.school_id.includes(getAbsenceReport.school_id));
                employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

                if (employeeResponses !== null) {
                    let employeeData = employeeResponses;
                    let employee = [];
                    employeeData.map((item) => {
                        let obj = {
                            name: (item.employee_name + ' ' + '(' + item.employee_code + ')'),
                            code: item.id
                        }
                        employee.push(obj);
                    })
                }
            }

            if (getAbsenceReport) {
                // var getAbsenceReportOfEmployee = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(getAbsenceReport.id))

                var getAbsenceReportOfEmployee = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: getAbsenceReport.id } }])

                let newResponse = [];
                let selEmpDate = [];
                let dataRec = [];
                let newEmp = '';
                let updatedate = [];
                for (var i = 0; i < getAbsenceReportOfEmployee.length; i++) {
                    //getAbsenceReportOfEmployee[i].employee_id
                    let employeeResponse = await getEmployeeDetails(getAbsenceReportOfEmployee[i].id, getAbsenceReportOfEmployee[i].employee_id);

                    employeeResponse.map((item) => item.selectedDate = new Date(moment(item.selectedDate).format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")))
                    //employeeResponse.map((item) =>setSelectedEmpDate([item.selectedDate]))
                    //employeeResponse.map((item) => selEmpDate[i] = item.selectedDate )

                    // let empName = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployee[i].employee_id));
                    let empName = allEmployeeList.find(o => o.id === getAbsenceReportOfEmployee[i].employee_id)

                    //dataRec[i] = {employeeName:'', selectedDate: selEmpDate[i], displayDate: selEmpDate[i], absentCode: '', absentId: '', nameOfTheSubstitute: '', hour: '', minute:'',}


                    if (empName) {
                        let obj1 = {
                            "name": (empName.employee_name + ' ' + '(' + empName.employee_code + ')'),
                            "code": empName.id
                        }

                        newEmp = empName.id;
                        //employeeListdata[i] = obj1
                        //setSelectedEmployee(obj1);
                    }
                    let data = {
                        "employeeName": empName.employee_name,
                        "employeeId": getAbsenceReportOfEmployee[i].employee_id,
                        "employeeResponse": employeeResponse
                    }

                    updatedate = [];
                    dataRec = []

                    // if(getAbsenceReportOfEmployee[i].employee_id === empid){
                    // for(var k=0; k< employeeResponse.length; k++ ){
                    // dataRec[k] = employeeResponse[k]
                    // dataRec[k].nameOfTheSubstitute =  dataRec[k].nameOfTheSubstitute.name ? {"name":dataRec[k].nameOfTheSubstitute.name ,"code": dataRec[k].nameOfTheSubstitute.code} : dataRec[k].nameOfTheSubstitute
                    ////updateEmpList.push({"name":dataRec[k].nameOfTheSubstitute.name ,"code": dataRec[k].nameOfTheSubstitute.code})
                    // setSelectedItem(employeeResponse[k].selectedDate)
                    // updatedate[k] = employeeResponse[k].selectedDate

                    // }	
                    // }

                    if (newResponse.length > 0) {
                        newResponse = [...newResponse, data];
                    } else {
                        newResponse.push(data)
                    }

                    let newdate = [];
                    if (i === getAbsenceReportOfEmployee.length - 1) {
                        let newR = mappedData.filter(item => item.employeeId === empid)
                        let countR = 0
                        let updName = []
                        for (let key in newR) {
                            if (newR[key] && newR[key].employeeResponse) {
                                for (var k = 0; k < newR[key].employeeResponse.length; k++) {
                                    dataRec[countR] = newR[key].employeeResponse[k]
                                    dataRec[countR].nameOfTheSubstitute = dataRec[countR].nameOfTheSubstitute.name ? { "name": dataRec[countR].nameOfTheSubstitute.name, "code": dataRec[countR].nameOfTheSubstitute.code } : dataRec[countR].nameOfTheSubstitute
                                    setSelectedItem(newR[key].employeeResponse[k].selectedDate)
                                    updatedate[countR] = newR[key].employeeResponse[k].selectedDate
                                    //updName[countR] = newR[key].employeeResponse[k].employeeName
                                    setSelectedName(newR[key].employeeResponse[k].employeeName)
                                    countR = countR + 1
                                }
                            }
                        }

                        //setSelectedEmployee(employeeListdata);
                        //setSelectedName(updName)
                        //setSelectedDateRecord(dataRec)
                        setSelectedDateFinal(dataRec)
                        setSelectedDateRecordNew(dataRec)
                        setIndexEditMode(true)
                        if (empid) {
                            newdate[empid] = updatedate

                        }
                        setDisabledDates(newdate)
                        //setUpdatedEmpList(updateEmpList);

                        //setMappcount
                        let innerArrayLength = 0;
                        let mapArry = mappedData.filter(item => item.employeeId === selectedEmployee.code)
                        for (var key in mapArry) {
                            innerArrayLength = innerArrayLength + mapArry[key].employeeResponse.length
                        }
                        setEmployeeWiseMapp(innerArrayLength)
                        setVisible(true);
                    }

                }

                let updatedList = [...selectedEmpDate, ...selEmpDate]
                setSelectedEmpDate(updatedList)
            }
        }

    }

    //All state clear
    const stateClear = () => {
        setAbsentDate([])
    };

    //Create  Initiate New Report
    const applyReport = async () => {
        setDisabled(true)
        setIndexEditMode(false)
        for (var vl = 0; vl < selectedDateRecord.length; vl++) {
            if (selectedDateRecord[vl].absentId === '' || selectedDateRecord[vl].absentId === null) {
                toast.error("Please select Absent code.")
                return
            }

            if (!selectedDateRecord[vl].is_full_day) {
                if ((selectedDateRecord[vl].hour === '' || selectedDateRecord[vl].hour === 0 || selectedDateRecord[vl].hour === null) && (selectedDateRecord[vl].minute === '' || selectedDateRecord[vl].minute === 0 || selectedDateRecord[vl].minute === null)) {
                    toast.error("Please select Total hours.")
                    return
                }
            }

        }

        if (selectedSchool !== null && selectedEmployee !== null && periodDates.length > 0 && selectedDateRecord[0].hour !== null) {

            //*set data to table
            if (mappedData.length > 0) {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)

                let getResponse = await getResponseFromKeyCertifiedAdmin(data, removeDuplicateArray, selectedEmployee.code, selectedDateRecord[0].employeeType);
                let object = getResponse[0];



                let myArray = [...mappedData, object];
                if (reportId) {
                    // let updatedData = mappedData.filter(item => item.employeeId !== selectedEmployee.code);
                    let updatedData = mappedData;
                    let object2 = []
                    let getAll = getResponse.map((item) => item.employeeResponse)

                    //sort by dates 
                    getResponse = getResponse.sort((a, b) => {
                        const dateA = new Date(a.employeeResponse[0].selectedDate);
                        const dateB = new Date(b.employeeResponse[0].selectedDate);
                        return dateA - dateB;
                    });

                    object2 = getResponse;
                    myArray = [...updatedData, ...object2];

                    //apply hide 
                    setApply(false)
                }

                myArray = myArray.sort((a, b) => {
                    const dateA = new Date(a.employeeResponse[0].selectedDate);
                    const dateB = new Date(b.employeeResponse[0].selectedDate);
                    return dateA - dateB;
                });

                const groupedData = myArray.reduce((acc, obj) => {
                    const existingObj = acc.find(item => item.employeeId === obj.employeeId);
                    if (existingObj) { existingObj.employeeResponse.push(...obj.employeeResponse); }
                    else { acc.push(obj); }
                    return acc;
                }, []);
                //sort by the employeename
                const sortedArray = groupedData.slice().sort((a, b) => {
                    const nameA = a.employeeName.toLowerCase();
                    const nameB = b.employeeName.toLowerCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });

                // remove duplicate records
                console.log("sortedArraysortedArray:-",sortedArray);
               
                sortedArray.map((item)=>
                {
                    let removeDeplicateRecords= (item.employeeResponse).flat().filter((selectedDate,index,self)=>self.indexOf(selectedDate)===index);
                    item.employeeResponse=removeDeplicateRecords;
                })
                
                console.log("sortedArraysortedArray uniqueDates:-",sortedArray);
                setMappedData(sortedArray);



                //setMappcount
                let innerArrayLength = 0;
                let mapArry = myArray.filter(item => item.employeeId === selectedEmployee.code)
                for (var key in mapArry) {
                    innerArrayLength = innerArrayLength + mapArry[key].employeeResponse.length
                }

                setEmployeeWiseMapp(innerArrayLength)


                //setSelectedDateRecord([]);



            } else {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKeyCertifiedAdmin(data, removeDuplicateArray, selectedEmployee.code, selectedDateRecord[0].employeeType)
                const groupedData = getResponse.reduce((acc, obj) => {
                    const existingObj = acc.find(item => item.employeeId === obj.employeeId);
                    if (existingObj) { existingObj.employeeResponse.push(...obj.employeeResponse); }
                    else { acc.push(obj); }
                    return acc;
                }, []);

                //sort by the employeename
                const sortedArray = groupedData.slice().sort((a, b) => {
                    const nameA = a.employeeName.toLowerCase();
                    const nameB = b.employeeName.toLowerCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });

                setMappedData(sortedArray);
            }

            if (reportId) {
                //
                // setSelectedDateFinal(selectedDateRecord)
            } else {
                setSelectedDateRecord([]);
            }


            let updated1 = [];
            if (skipDisable.length > 0) {
                updated1 = [...skipDisable, selectedEmployee.code];
            } else {
                updated1.push(selectedEmployee.code)
            }



            //disable date 
            let datesArray = []
            let finalDate = []
            for (let i = 0; i < selectedDateRecord.length; i++) {
                datesArray[i] = selectedDateRecord[i].selectedDate
            }
            finalDate[selectedEmployee.code] = datesArray;
            setSkipDisable(datesArray)
            //let date
            let updatedList = [];

            if (skipDisable.length > 0) {
                let y = 0;
                for (var key in disabledDates) {
                    y = y + 1;
                    if (key === selectedEmployee.code) {
                        updatedList[key] = [...disabledDates[key], ...finalDate[key]]
                    } else {
                        updatedList[key] = disabledDates[key]
                        updatedList[selectedEmployee.code] = datesArray
                    }


                }

            } else { updatedList = finalDate }
            setDisabledDates(updatedList)
            setVisible(true);
            stateClear()
        } else {
            toast.error("Select mandatory fields.")
            if (reportId) { setVisible(true); } else { setVisible(false); }
        }

    }


    const goBack = () => {
        // if (warCerReqIsSuperadmin ) {
        //     navigateTo("/weekly_absent_report_certificated_admin/SuperAdminDashboard")   
        // }else{
        //     navigateTo(`${loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin' : '/initiator/weekly_absent_report_certificated_admin'}`);
        // }
        navigateTo(
        (type==="SAEdit")?'/weekly_absent_report_certificated_admin/SuperAdminDashboard':
        loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin' :
         '/initiator/weekly_absent_report_certificated_admin');

    }
    //*save Report
    const saveReport = async (status) => {

        // if l2Authority is undefined then // get user id from .env(by default payroll) user email
        if (loggedl2authority == 'undefined') {
            var payrollEmpData = await graphQLGetAllData("listEmployees", [{ email: { eq: process.env.REACT_APP_Certificated_Email } }])
            console.log("loggedl2authority und:", payrollEmpData[0]?.user_Id);
            loggedl2authority = payrollEmpData[0]?.user_Id;
        }

        if (status === Request_Status.S && selectApprover.length === 0) { toast.error("Please select Approver"); return }

        if (!isNoAbsence) {
            if (mappedData.length === 0) { toast.error("Please select employee data"); return }
        } else {
            if (periodDates.length === 0) { toast.error("Please select period dates"); return }
        }

       
        if(status === Request_Status.S 
            // && type==="copyReport"
            ){
            //check employees dates is matched with period or not
            let sortedData=[];
            let startDate=moment(periodDates[0]).format('MM/DD/YYYY');
            let endDate=moment(periodDates[1]).format('MM/DD/YYYY');
           
            let inValidRecordCount=0;
            let inValidRecord=[];
            mappedData.map(data=>{

                let particularEmpDates=data.employeeResponse;
                for(let i=0;i<particularEmpDates.length;i++){

                    let selectedDate=moment(particularEmpDates[i].selectedDate).format('MM/DD/YYYY');

                    if(selectedDate >= startDate && selectedDate <= endDate){
                        particularEmpDates[i].isWrong=false;
                    }else{
                        inValidRecordCount++;
                        particularEmpDates[i].isWrong=true;
                        inValidRecord.push(particularEmpDates[i].selectedDate);
                    }
                }
                sortedData.push(data);                
            })
       
            if(inValidRecordCount > 0){
                setAbsentDate(inValidRecord);
                setMappedData(sortedData);
                toast.error("Please make necessary date modifications before submitting the form");
                return;
            }
        }
        
        setPleaseWaitButton(false);
        if (reportId) {
            //debugger;
            // await DataStore.delete(CertificatedAdminWeeklyAbsenceReport, (c) => c.id.eq(reportId)).then(async (response) => {
            //     await DataStore.delete(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(reportId)).then(async (response) => {



            //         await DataStore.delete(CertificatedAdminWeeklyAbsenceReportEmployeeDetails, (c) => c.Certificated_Admin_Weekly_Absence_Report_Employee_id.eq(response.id)).then(async (response) => {
            //             CommenFunction(status)
            //         })
            //     })
            // })

            if(type==="copyReport"){
                CommenFunction(status)
            }else if(type==="SAEdit"){
                try{
                let firstQuery = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)

                //---------------------------------------------------------
                    if(status===CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED){
                     
                        var updateInitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
                            graphqlOperation(mutations.updateCertificatedAdminWeeklyAbsenceReport, {
                                input: {
                                    id: firstQuery.id,
                                    _version: firstQuery._version,
                                    // user_id: loggedUserId,
                                    from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                    to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                                    status: CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED,

                                    approver_by: null,
                                    approver_date_time: null,
                                    approver_remark: null,
                                    approver_status: null,


                                    l1_authority: selectApprover.code,
                                    l2_authority: loggedl2authority,
                                    school_id: selectedSchool.code,
                                    status_date_time: moment(currentDateTime).toISOString(),
                                    // approver_remark: remark,
                                    comment: comment,
                                }
                            })
                        );
                    }else{
                       
                        var updateInitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
                            graphqlOperation(mutations.updateCertificatedAdminWeeklyAbsenceReport, {
                                input: {
                                    id: firstQuery.id,
                                    _version: firstQuery._version,
                                    // user_id: loggedUserId,
                                    from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                    to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                                    l1_authority: selectApprover.code,
                                    l2_authority: loggedl2authority,
                                    school_id: selectedSchool.code,
                                    // status_date_time: moment(currentDateTime).toISOString(),
                                    // status: CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED,
                                    // approver_by: null,
                                    // approver_date_time: null,
                                    // approver_remark: null,
                                    // approver_status: null,
                                    // approver_remark: remark,
                                    // comment: comment,
                                }
                            })
                        );
                    }
                    console.log("updateInitiateClassifiedWeeklyAbsenceReportId:-", updateInitiateClassifiedWeeklyAbsenceReportId);

                    //delete employee 
                    let secondQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: reportId } }])
                    for (let j = 0; j < secondQuery.length; j++) {
                        let deletedRecord = await API.graphql({
                            query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployee,
                            variables: {
                                input: {
                                    id: secondQuery[j].id,
                                    _version: secondQuery[j]._version
                                }
                            }
                        });

                        let thirdQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: deletedRecord.data.deleteCertificatedAdminWeeklyAbsenceReportEmployee.id } }])
                        for (let k = 0; k < thirdQuery.length; k++) {
                            await API.graphql({
                                query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails,
                                variables: {
                                    input: {
                                        id: thirdQuery[k].id,
                                        _version: thirdQuery[k]._version
                                    }
                                }
                            });
                        }
                    }

                    //---------------------
                    try {
                        if (updateInitiateClassifiedWeeklyAbsenceReportId) {
                            let oldReportId = updateInitiateClassifiedWeeklyAbsenceReportId?.data?.updateCertificatedAdminWeeklyAbsenceReport?.id;
                            let originalInitiatorId=updateInitiateClassifiedWeeklyAbsenceReportId?.data?.updateCertificatedAdminWeeklyAbsenceReport?.user_id;

                            if (oldReportId) {

                                for (var i = 0; i < mappedData.length; i++) {

                                    var initiateClassifiedWeeklyAbsenceReportEmployee = await API.graphql(
                                        graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployee, {
                                            input: {
                                                Certificated_Admin_Weekly_Absence_Report_id: oldReportId,
                                                employee_id: mappedData[i].employeeId,
                                                employee_type: mappedData[i].employeeType,
                                            }
                                        })
                                    );
                                    saveEmployeeDetails(initiateClassifiedWeeklyAbsenceReportEmployee.data.createCertificatedAdminWeeklyAbsenceReportEmployee.id, mappedData[i].employeeResponse, mappedData[i].employeeType)

                                    if (i === mappedData.length - 1) {
                                        toast.success('Data Added Successfully.');
                                        { goBack() }
                                    }
                                }

                                //submit onclick add new entry to the transaction cycle table.
                                if (status == CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED) {

                                    let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listWARCertificatedTransactionCycles"
                                        , [{ reportId: { eq: oldReportId } }]
                                    )

                                    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                                    if (particulerReportAllTransactionCycleRecord.length > 0) {
                                        particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                                        console.log("newFetchnewFetch:-", particulerReportAllTransactionCycleRecord[0]?.id);

                                        const updatedCyclePost = await API.graphql({
                                            query: mutations.updateWARCertificatedTransactionCycle,
                                            variables: {
                                                input: {
                                                    id: particulerReportAllTransactionCycleRecord[0].id,
                                                    _version: particulerReportAllTransactionCycleRecord[0]._version,
                                                    status: 'Resubmit',
                                                    isApproved: 'true',
                                                    toEmployeeId:loggedUserId,
                                                    customUpdatedAt: currentDateTime
                                                }
                                            }
                                        });

                                        if (updatedCyclePost) {

                                            await API.graphql(
                                                graphqlOperation(mutations.createWARCertificatedTransactionCycle, {
                                                    input: {
                                                        reportId: oldReportId,
                                                        // fromEmployeeId: updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.id ? updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.user_id : '-',
                                                        fromEmployeeId: loggedUserId,
                                                        toEmployeeId: updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.id ? updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.l1_authority : '--',
                                                        status: 'Open',
                                                        isApproved: 'false',
                                                        customUpdatedAt: currentDateTime,
                                                    }
                                                })
                                            );
                                        }
                                    }
                            // await handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin('CREATED', oldReportId, "WEEKLY_ABSENCE_REPORT_ADMIN", selectApprover.code, loggedUserId);
                            await handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin('CREATED', oldReportId, "WEEKLY_ABSENCE_REPORT_ADMIN", selectApprover.code, originalInitiatorId);
                                }
                            }

                            if (mappedData.length === 0 && isNoAbsence) {
                                toast.success('Data Added Successfully.');
                                { goBack() }
                            }
                        }



                    } catch (error) {
                        console.log("Error while resubmit data", error);
                    }
                    //---------------------
                //---------------------------------------------------------
            }catch(err){console.log("Error when Update Super Admin:-",err);}
            }
            
            else{

            // Need to test
            let firstQuery = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", reportId)
            console.log("firstQueryfirstQuery:-", firstQuery);

            if (loggedUserRole === "AP") {

                var newInitiateClassifiedWeeklyAbsenceReportId;
                var InitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
                    graphqlOperation(mutations.updateCertificatedAdminWeeklyAbsenceReport, {
                        input: {
                            id: firstQuery.id,
                            _version: firstQuery._version,
                            // user_id: loggedUserId,
                            // from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                            // to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                            // status: status,
                            // l1_authority: selectApprover.code,
                            // l2_authority: loggedl2authority,
                            // school_id: selectedSchool.code,
                            // status_date_time: moment(currentDateTime).toISOString(),
                            // approver_remark: remark,
                            comment: comment,
                        }
                    })
                );
                newInitiateClassifiedWeeklyAbsenceReportId = InitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport
                    .id;

                if (newInitiateClassifiedWeeklyAbsenceReportId) {

                    let secondQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: reportId } }])

                    for (let j = 0; j < secondQuery.length; j++) {
                        let deletedRecord = await API.graphql({
                            query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployee,
                            variables: {
                                input: {
                                    id: secondQuery[j].id,
                                    _version: secondQuery[j]._version
                                }
                            }
                        });

                        let thirdQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: deletedRecord.data.deleteCertificatedAdminWeeklyAbsenceReportEmployee.id } }])

                        for (let k = 0; k < thirdQuery.length; k++) {
                            await API.graphql({
                                query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails,
                                variables: {
                                    input: {
                                        id: thirdQuery[k].id,
                                        _version: thirdQuery[k]._version
                                    }
                                }
                            });
                        }
                    }

                    for (var i = 0; i < mappedData.length; i++) {

                        var initiateClassifiedWeeklyAbsenceReportEmployee = await API.graphql(
                            graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployee, {
                                input: {
                                    Certificated_Admin_Weekly_Absence_Report_id: newInitiateClassifiedWeeklyAbsenceReportId,
                                    employee_id: mappedData[i].employeeId,
                                    employee_type: mappedData[i].employeeType,
                                }
                            })
                        );

                        saveEmployeeDetails(initiateClassifiedWeeklyAbsenceReportEmployee.data.createCertificatedAdminWeeklyAbsenceReportEmployee.id, mappedData[i].employeeResponse, mappedData[i].employeeType)

                        if (i === mappedData.length - 1) {
                            toast.success('Data Added Successfully.');
                            if (status === Request_Status.S) {
                                // if (warCerReqIsSuperadmin ) {
                                //     navigateTo("/weekly_absent_report_certificated_admin/SuperAdminDashboard")   
                                // }else{
                                //     navigateTo(`${loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin/' + reportId : '/initiator/weekly_absent_report_certificated_admin'}`);
                                // }
                                navigateTo(`${loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin/' + reportId : '/initiator/weekly_absent_report_certificated_admin'}`);
                                // navigateTo(0);
                            } else {
                                { goBack() }
                            }
                        }
                    }
                }
            } else {

                //resubmit----------------------------
                if (firstQuery.status != "OPEN") {
                    var updateInitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
                        graphqlOperation(mutations.updateCertificatedAdminWeeklyAbsenceReport, {
                            input: {
                                id: firstQuery.id,
                                _version: firstQuery._version,
                                user_id: loggedUserId,
                                from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                                status: CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED,

                                approver_by: null,
                                approver_date_time: null,
                                approver_remark: null,
                                approver_status: null,


                                l1_authority: selectApprover.code,
                                l2_authority: loggedl2authority,
                                school_id: selectedSchool.code,
                                status_date_time: moment(currentDateTime).toISOString(),
                                // approver_remark: remark,
                                comment: comment,
                            }
                        })
                    );
                    console.log("updateInitiateClassifiedWeeklyAbsenceReportId:-", updateInitiateClassifiedWeeklyAbsenceReportId);

                    //delete employee 
                    let secondQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: reportId } }])
                    for (let j = 0; j < secondQuery.length; j++) {
                        let deletedRecord = await API.graphql({
                            query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployee,
                            variables: {
                                input: {
                                    id: secondQuery[j].id,
                                    _version: secondQuery[j]._version
                                }
                            }
                        });

                        let thirdQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: deletedRecord.data.deleteCertificatedAdminWeeklyAbsenceReportEmployee.id } }])
                        for (let k = 0; k < thirdQuery.length; k++) {
                            await API.graphql({
                                query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails,
                                variables: {
                                    input: {
                                        id: thirdQuery[k].id,
                                        _version: thirdQuery[k]._version
                                    }
                                }
                            });
                        }
                    }

                    //---------------------
                    try {
                        if (updateInitiateClassifiedWeeklyAbsenceReportId) {
                            let oldReportId = updateInitiateClassifiedWeeklyAbsenceReportId?.data?.updateCertificatedAdminWeeklyAbsenceReport?.id;

                            if (oldReportId) {

                                for (var i = 0; i < mappedData.length; i++) {

                                    var initiateClassifiedWeeklyAbsenceReportEmployee = await API.graphql(
                                        graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployee, {
                                            input: {
                                                Certificated_Admin_Weekly_Absence_Report_id: oldReportId,
                                                employee_id: mappedData[i].employeeId,
                                                employee_type: mappedData[i].employeeType,
                                            }
                                        })
                                    );
                                    saveEmployeeDetails(initiateClassifiedWeeklyAbsenceReportEmployee.data.createCertificatedAdminWeeklyAbsenceReportEmployee.id, mappedData[i].employeeResponse, mappedData[i].employeeType)

                                    if (i === mappedData.length - 1) {
                                        toast.success('Data Added Successfully.');

                                        { goBack() }
                                    }
                                }

                                //submit onclick add new entry to the transaction cycle table.
                                if (status == CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED) {

                                    let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listWARCertificatedTransactionCycles"
                                        , [{ reportId: { eq: oldReportId } }]
                                    )

                                    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                                    if (particulerReportAllTransactionCycleRecord.length > 0) {
                                        particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                                        console.log("newFetchnewFetch:-", particulerReportAllTransactionCycleRecord[0]?.id);

                                        const updatedCyclePost = await API.graphql({
                                            query: mutations.updateWARCertificatedTransactionCycle,
                                            variables: {
                                                input: {
                                                    id: particulerReportAllTransactionCycleRecord[0].id,
                                                    _version: particulerReportAllTransactionCycleRecord[0]._version,
                                                    status: 'Resubmit',
                                                    isApproved: 'true',
                                                    customUpdatedAt: currentDateTime
                                                }
                                            }
                                        });

                                        if (updatedCyclePost) {

                                            await API.graphql(
                                                graphqlOperation(mutations.createWARCertificatedTransactionCycle, {
                                                    input: {
                                                        reportId: oldReportId,
                                                        fromEmployeeId: updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.id ? updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.user_id : '-',
                                                        toEmployeeId: updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.id ? updateInitiateClassifiedWeeklyAbsenceReportId.data.updateCertificatedAdminWeeklyAbsenceReport.l1_authority : '--',
                                                        status: 'Open',
                                                        isApproved: 'false',
                                                        customUpdatedAt: currentDateTime,
                                                    }
                                                })
                                            );
                                        }
                                    }
                                }
                            }
                            await handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin('CREATED', newInitiateClassifiedWeeklyAbsenceReportId, "WEEKLY_ABSENCE_REPORT_ADMIN", selectApprover.code, loggedUserId);

                            if (mappedData.length === 0 && isNoAbsence) {
                                toast.success('Data Added Successfully.');
                                { goBack() }
                            }
                        }



                    } catch (error) {
                        console.log("Error while resubmit data", error);
                    }
                    //---------------------
                } else {
                    await API.graphql({
                        query: mutations.deleteCertificatedAdminWeeklyAbsenceReport,
                        variables: {
                            input: {
                                id: firstQuery.id,
                                _version: firstQuery._version
                            }
                        }
                    });

                    let secondQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: reportId } }])

                    for (let j = 0; j < secondQuery.length; j++) {
                        let deletedRecord = await API.graphql({
                            query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployee,
                            variables: {
                                input: {
                                    id: secondQuery[j].id,
                                    _version: secondQuery[j]._version
                                }
                            }
                        });

                        let thirdQuery = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: deletedRecord.data.deleteCertificatedAdminWeeklyAbsenceReportEmployee.id } }])

                        for (let k = 0; k < thirdQuery.length; k++) {
                            await API.graphql({
                                query: mutations.deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails,
                                variables: {
                                    input: {
                                        id: thirdQuery[k].id,
                                        _version: thirdQuery[k]._version
                                    }
                                }
                            });
                        }
                    }
                    CommenFunction(status)
                }



                //without delete report we update that.
                // await API.graphql({
                //     query: mutations.deleteCertificatedAdminWeeklyAbsenceReport,
                //     variables: {
                //         input: {
                //             id: firstQuery.id,
                //             _version: firstQuery._version
                //         }
                //     }
                // });


                // CommenFunction(status)
            }                   
        }
        } else {
            //debugger;
            CommenFunction(status)
        }
    }

    const CommenFunction = async (status) => {

        // save ALL data to datastore
        var newInitiateClassifiedWeeklyAbsenceReportId;


        // var InitiateClassifiedWeeklyAbsenceReportId = await DataStore.save(
        //     new CertificatedAdminWeeklyAbsenceReport({
        //         "user_id": loggedUserId,
        //         "from_date": moment(periodDates[0]).format("YYYY-MM-DD"),
        //         "to_date": moment(periodDates[1]).format("YYYY-MM-DD"),
        //         "status": status,
        //         "l1_authority": selectApprover.code,
        //         "l2_authority": loggedl2authority,
        //         "school_id": selectedSchool.code,
        //         "status_date_time": moment(currentDateTime).toISOString(),
        //         "approver_remark": remark,
        //         "comment": comment,
        //     })
        // );

        var InitiateClassifiedWeeklyAbsenceReportId = await API.graphql(
            graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReport, {
                input: {
                    user_id: loggedUserId,
                    from_date: moment(periodDates[0]).format("YYYY-MM-DD"),
                    to_date: moment(periodDates[1]).format("YYYY-MM-DD"),
                    status: status,
                    l1_authority: selectApprover.code,
                    l2_authority: loggedl2authority,
                    school_id: selectedSchool.code,
                    status_date_time: moment(currentDateTime).toISOString(),
                    approver_remark: remark,
                    comment: comment,
                }
            })
        );

        newInitiateClassifiedWeeklyAbsenceReportId = InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.id;
        if (newInitiateClassifiedWeeklyAbsenceReportId) {
            console.log("InitiateClassifiedWeeklyAbsenceReportId admin", InitiateClassifiedWeeklyAbsenceReportId);

            if (status !== Request_Status.O) {
                await handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin('CREATED', newInitiateClassifiedWeeklyAbsenceReportId, "WEEKLY_ABSENCE_REPORT_ADMIN", selectApprover.code, loggedUserId);
            }

            for (var i = 0; i < mappedData.length; i++) {

                // //Save CertificatedAdminWeeklyAbsenceReportEmployee
                // var initiateClassifiedWeeklyAbsenceReportEmployee = await DataStore.save(
                //     new CertificatedAdminWeeklyAbsenceReportEmployee({
                //         "Certificated_Admin_Weekly_Absence_Report_id": newInitiateClassifiedWeeklyAbsenceReportId,
                //         "employee_id": mappedData[i].employeeId,
                //         "employee_type": mappedData[i].employeeType,
                //     })
                // ).then(async (data) => {
                //     saveEmployeeDetails(data.id, mappedData[i].employeeResponse, mappedData[i].employeeType)
                // })

                var initiateClassifiedWeeklyAbsenceReportEmployee = await API.graphql(
                    graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployee, {
                        input: {
                            Certificated_Admin_Weekly_Absence_Report_id: newInitiateClassifiedWeeklyAbsenceReportId,
                            employee_id: mappedData[i].employeeId,
                            employee_type: mappedData[i].employeeType,
                        }
                    })
                );

                saveEmployeeDetails(initiateClassifiedWeeklyAbsenceReportEmployee.data.createCertificatedAdminWeeklyAbsenceReportEmployee.id, mappedData[i].employeeResponse, mappedData[i].employeeType)


                if (i === mappedData.length - 1) {
                    if(type==="copyReport"){
                        toast.success("The form has been cloned");
                    }else{
                    toast.success('Data Added Successfully.');
                    }
                    if (status === Request_Status.S) {
                        // if (warCerReqIsSuperadmin ) {
                        //     navigateTo("/weekly_absent_report_certificated_admin/SuperAdminDashboard")   
                        // }else{
                        //     navigateTo(`${loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin' : '/initiator/weekly_absent_report_certificated_admin'}`);
                        // }
                        navigateTo(`${loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin' : '/initiator/weekly_absent_report_certificated_admin'}`);
                        // navigateTo(0);
                    } else if (status === Request_Status.O) {
                        //stay on same page    
                        // if (warCerReqIsSuperadmin ) {
                        //     navigateTo("/weekly_absent_report_certificated_admin/SuperAdminDashboard")   
                        // }else{
                        //     setIsPendingRequest(true);
                        //     navigateTo("/initiator/weekly_absent_report_certificated_admin_initiatereport/" + newInitiateClassifiedWeeklyAbsenceReportId);
                        // }
                        setIsPendingRequest(true);
                        navigateTo("/initiator/weekly_absent_report_certificated_admin_initiatereport/" + newInitiateClassifiedWeeklyAbsenceReportId);

                    } else {
                        { goBack() }
                    }
                }
            }

            //submit onclick add new entry to the transaction cycle table.
            if (status == CertificatedAdminWeeklyAbsenceReportStatus.SUBMITTED) {
                const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");

                try {
                    await API.graphql(
                        graphqlOperation(mutations.createWARCertificatedTransactionCycle, {
                            input: {
                                reportId: newInitiateClassifiedWeeklyAbsenceReportId,
                                fromEmployeeId: InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.id ? InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.user_id : '-',
                                toEmployeeId: InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.id ? InitiateClassifiedWeeklyAbsenceReportId.data.createCertificatedAdminWeeklyAbsenceReport.l1_authority : '--',
                                status: 'Open',
                                isApproved: 'false',
                                customUpdatedAt: currentDateTime,
                            }
                        })
                    );
                } catch (error) {
                    console.log("Error in transaction cycle upload:", error);
                }

            }
        }

        if (mappedData.length === 0 && isNoAbsence) {
            if(type==="copyReport"){
                toast.success("The form has been cloned");
            }else{
            toast.success('Data Added Successfully.');
            }
            //in case of no absence redirect user
            if (Request_Status.S === status) {
                { goBack() }
            }
            if (Request_Status.O === status) {
                // if (warCerReqIsSuperadmin ) {
                //     navigateTo("/weekly_absent_report_certificated_admin/SuperAdminDashboard")   
                // }else{
                //     navigateTo("/initiator/weekly_absent_report_certificated_admin_initiatereport/" + newInitiateClassifiedWeeklyAbsenceReportId);
                // }
                navigateTo("/initiator/weekly_absent_report_certificated_admin_initiatereport/" + newInitiateClassifiedWeeklyAbsenceReportId);

                navigateTo(0);
            } else {
                { goBack() }
            }

        }

    }

    //*Save Employee Details
    const saveEmployeeDetails = async (initiateClassifiedWeeklyAbsenceReportEmployeeId, employeeDetailsData, employee_type) => {
        if (employeeDetailsData.length > 0) {
            for (let i = 0; i < employeeDetailsData.length; i++) {

                let hour = 24
                let minute = 59
                if (!Number.isInteger(employeeDetailsData[i].hour)) {
                    hour = parseInt(employeeDetailsData[i].hour, 10);
                }
                if (!isNaN(employeeDetailsData[i].hour)) {
                    hour = parseInt(employeeDetailsData[i].hour, 10);

                }

                if (!Number.isInteger(employeeDetailsData[i].minute)) {
                    minute = parseInt(employeeDetailsData[i].minute, 10);
                }
                if (!isNaN(employeeDetailsData[i].minute)) {
                    minute = parseInt(employeeDetailsData[i].minute, 10);

                }


                // await DataStore.save(
                //     new CertificatedAdminWeeklyAbsenceReportEmployeeDetails({
                //         "Certificated_Admin_Weekly_Absence_Report_Employee_id": initiateClassifiedWeeklyAbsenceReportEmployeeId,
                //         "absent_code_id": employeeDetailsData[i].absentCode.code,
                //         "substitute_emp_id": employeeDetailsData[i].nameOfTheSubstitute.name,  //employeeDetailsData[i].nameOfTheSubstitute.code,
                //         "is_full_day": employeeDetailsData[i].is_full_day,
                //         "partial_hour": hour,
                //         "partial_min": minute,
                //         "employee_type": employee_type,
                //         "absent_date": moment(employeeDetailsData[i].selectedDate,).format("YYYY-MM-DD")
                //     })
                // );


                await API.graphql(
                    graphqlOperation(mutations.createCertificatedAdminWeeklyAbsenceReportEmployeeDetails, {
                        input: {
                            Certificated_Admin_Weekly_Absence_Report_Employee_id: initiateClassifiedWeeklyAbsenceReportEmployeeId,
                            absent_code_id: employeeDetailsData[i].absentCode.code,
                            substitute_emp_id: employeeDetailsData[i].nameOfTheSubstitute.name,  //employeeDetailsData[i].nameOfTheSubstitute.code,
                            is_full_day: employeeDetailsData[i].is_full_day,
                            partial_hour: hour,
                            partial_min: minute,
                            employee_type: employee_type,
                            absent_date: moment(employeeDetailsData[i].selectedDate,).format("YYYY-MM-DD")
                        }
                    })
                );


            }
        }
    }

    const CalendarValidation = () => {
        toast.error("Please select Employee.")
    }

    const onSetEmployee = (e) => {
        // debugger
        setSelectedEmployee(e.value);

        if (e.value.code === "1") {
            setIsNoAbsence(true)
            setVisible(true)
        }
        else {
            setIsNoAbsence(false)
        }

        setDateCount(0);
        if (reportId 
            // && type!=="copyReport"
            ) {
            let newR = mappedData.filter(item => item.employeeId === e.value.code)
            if (newR.length > 0) {
                const indx = mappedData.findIndex(item => item.employeeId === e.value.code);
                setMapDataIndex(indx)
            } else {
                setMapDataIndex(mappedData.length + 1)
            }

            getDataOnChange(e.value.code)
            //getEmpDataOnChange(e.value.code)
        } else {
            setSelectedDateRecord([]);
        }

        //create new list without selected employee
        let newEmpList = [];
        employeeList.map((currentItem) => {
            if (currentItem.code !== e.value.code) {
                newEmpList.push(currentItem);
            }
        })
        setUpdatedEmpList(newEmpList);
    }

    const fetchPaginatedRecords = async (query, filter, sort, limit, resultKey, checkDeleted = true) => {
        let allRecords = [];
        let nextToken = null;
        let variables = checkDeleted ? { _deleted: { eq: null } } : {};
        // Add to query variables that are not null
        filter && (variables.filter = filter);
        limit && (variables.limit = 3000);
        sort && (variables.sort = sort);
        do {
            variables.nextToken = nextToken;
            const result = await API.graphql(graphqlOperation(query, variables));
            const { items, nextToken: newNextToken } = result.data[resultKey];

            allRecords = [...allRecords, ...items];
            nextToken = newNextToken;
        } while (nextToken);
        return allRecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    };

    const getMasterData = async () => {
        let schoolsArray = await graphQLGetAllData("listSchools")
        schoolsArray = schoolsArray.sort((a, b) => a.name.localeCompare(b.name));

        var schoolArray = [];
        schoolArray = ConvertResponseForSelect(schoolsArray);
        setAllSchoolList(schoolsArray)
        setSchoolList(schoolArray);

        // let employeeList = await graphQLGetAllData("listEmployees");
        let employeeList = await fetchPaginatedRecords(
            queries.listEmployees,
            null,
            { field: "employee_name", direction: "asc" },
            3000,
            'listEmployees'
        );
        //employee delete
        employeeList = employeeList.filter(item => item._deleted !== true);
        setAllEmployeeList(employeeList);

        // var AbsentCodeResponses = await DataStore.query(AbsentCode, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        let AbsentCodeResponses = await graphQLGetAllData("listAbsentCodes");
        AbsentCodeResponses = AbsentCodeResponses.sort((a, b) => (a.name?.toLowerCase() ?? "").localeCompare(b.name?.toLowerCase() ?? ""));

        setAbsentCodeList(AbsentCodeResponses)
        var myArray = []; myArray = ConvertResponseForSelectWithRefCode(AbsentCodeResponses); setAbsentCodeListDropdown(myArray);

        setIsMasterDataLoaded(true)
        //load roving substitute user
        await loadRovingUsers();
    }

    useEffect(() => {
        onLoad();
        getMasterData();
        setVisibleDialogue(false)
        checkApplicationAccessibility()
    }, []);

    useEffect(() => {
        if (isMasterDataLoaded === true) {
            BindList();
            LoadUsers();
            UserList();
        }
    }, [isMasterDataLoaded]);


    return isAuthenticated ? (
        <>
            <Layout pageTitle="Homepage" 
            // activeMenu={warCerReqIsSuperadmin ? "SuperAdmin" : "Initiator"} 
            activeMenu={"Initiator"} 
            appId={"WEEKLY_ABSENCE_CERTIFIED"} IsSuperadmin={warCerReqIsSuperadmin} reDirectUrl={"/weekly_absent_report_certificated_admin/SuperAdminDashboard"}>
                <div className="">
                    <div className="pt-24 md:pt-28 xl:pt-[2.083vw]">
                        <div className="">

                            <div className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                <h3>Initiate New Report</h3>
                            </div>
                            {status === "Rejected" ?
                                <div className="">
                                    <div className=" mt-10  flex flex-wrap xl:flex-nowrap gap-4 mt-5 xl:gap-[0.938vw] xl:mt-[1.250vw] w-1/2">
                                        <h3 className="text-[#113699]  py-4 font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]" >Remark</h3>

                                        <textarea placeholder='' value={remark} rows="4" cols="50" type="text" readOnly={true} className=" text-[#344054] text-[16px] a rounded-lg disabled bg-[#fff] flex-1 appearance-none border border-[#D0D5DD]  py-2 px-4 bg-grey text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#8E8E8E]" ></textarea>
                                    </div>
                                </div> : null}
                        </div>

                        <div className="mt-5 xl:mt-[1.250vw]">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[0.833vw] cust-select">
                                {/*------School or Departament-----*/}

                                <div className="w-full">
                                    <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of School or Department <span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="relative">
                                        <i className="gusd-employee text-[#667085] text-sm absolute  top-[0.677vw] left-[0.8rem] cstmIconClass z-10"></i>
                                        <Dropdown id="dept" value={selectedSchool}
                                            onChange={(e) => {
                                                if(type === "copyReport" || type==="SAEdit"){
                                                    let isConfirm=window.confirm(" Alert All data in the preview section will be deleted. Confirm your choice below.");
                                                    if(isConfirm){
                                                        // setTeachers([{ teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }]);
                                                        // getSpecificSchoolOrDeptEmployees(e);
                                                        setMappedData([]);
                                                        setSelectedDateRecord([]);
                                                        setSelectedDateFinal([]);
                                                        setSelectedEmployee(null);
                                                        EmployeeList(e)
                                                        setDateCount(0);
                                                    }else{
                                                        return 0;
                                                    }
                                                }else{
                                                    EmployeeList(e)
                                                    setDateCount(0);
                                                }
                                            }}

                                            filter
                                            disabled={disabled}
                                            options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                        />
                                    </div>
                                </div>

                                {/*------School or Departament-----*/}
                                <div className="w-full">
                                    <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Employee <span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="relative flex">
                                        <i className="gusd-employee text-[#667085] text-sm absolute top-[0.677vw] left-[0.8rem] cstmIconClass z-10"></i>
                                        <Dropdown id="employee"
                                            value={selectedEmployee}
                                            onChange={(e) => { onSetEmployee(e); setAbsentDate([]) }} options={employeeList}
                                            filter
                                            optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                            {/* <i className='gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i> */}
                                            <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                            <i className='icon-tooltip gusd-pluse-circle' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                        </div>
                                    </div>
                                </div>
                                {/* Add New Employee Popup */}
                                <Dialog
                                    header="Add New Employee" draggable={false} className='add_New_Employee'
                                    visible={openNewEmployee}
                                    style={{ width: "30vw" }}

                                    onHide={() => {
                                        setOpenNewEmployee(false);

                                    }}
                                // footer={footerContentForReqReject}
                                >
                                    <div className="m-0">

                                        <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                        <Dropdown id="dept" value={selectedSchool}
                                            onChange={(e) => { EmployeeList(e); setNewEmployeeSchool(e.value) }}
                                            filter
                                            disabled={disabled}
                                            options={schoolList} optionLabel="name" placeholder="Select School/Department" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                        />
                                        {/* <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={NewEmployeeName}
                                            placeholder=""
                                            onChange={e => { setNewEmployeeName(e.target.value) }}
                                            className="w-full"
                                        /> */}
                                        <div className="font-medium text-sm mb-2 mt-3">First Name <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={newEmpFirstName}
                                            placeholder="Enter First Name"
                                            onChange={e => { setNewEmpFirstName(e.target.value) }}
                                            className="w-full"
                                        />
                                        <div className="font-medium text-sm mb-2 mt-3">Last Name <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={newEmpLastName}
                                            placeholder="Enter Last Name"
                                            onChange={e => { setNewEmpLastName(e.target.value) }}
                                            className="w-full"
                                        />
                                        {/* <div className="font-medium text-[18px] mb-2 mt-3">Select Role 
                                        <span className="text-[red] pl-0.2">*</span>
                                        </div>
                                        <Dropdown value={newEmpSelectedRole} onChange={(e) => setNewEmpSelectedRole(e.value)} options={rolesArray} optionLabel="name"
                                            placeholder="Select a Role" className="w-full md:w-14rem" />

                                        <div className="font-medium text-[18px] mb-2 mt-3">Designation<span className="text-[red] pl-0.2">*</span></div>
                                        <Dropdown value={newEmpSelectedDesignation} onChange={(e) => setNewEmpSelectedDesignation(e.value)} options={designationForAllApps} optionLabel="name"
                                            placeholder="Select a Designation" className="w-full md:w-14rem" /> */}
                                        {/* -------------------------------- */}



                                        <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={NewEmployeeCode}
                                            placeholder="Enter Employee Code"
                                            onChange={e => { setNewEmployeeCode(e.target.value) }}
                                            className="w-full"
                                        />

                                        <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                        <InputText
                                            value={NewEmployeeEmail}
                                            placeholder="Enter Employee Email Address"
                                            onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                            className="w-full"
                                        />


                                        <div className="font-medium text-sm mb-2 mt-3">Employee Type <span className="text-[red] pl-0.2">*</span></div>
                                        <Dropdown id="employee"
                                            value={employeeTypeField}
                                            onChange={(e) => { setEmployeeTypeField(e.value); }} options={employeeTypeList}
                                            filter
                                            optionLabel="name" placeholder="Select Employee Type" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />


                                    </div>
                                    <div className='flex justify-between gap-2 mt-3'>
                                        <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                            className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                            <i class="pi pi-times"></i><span>Cancel</span></Link>

                                        <Link to="" onClick={() => { AddNewEmployee() }}
                                            className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                            <i class="pi pi-check"></i><span>Add</span></Link>

                                    </div>
                                </Dialog>
                                <div className="w-full">
                                    <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Approver<span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="relative">
                                        <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.677vw] cstmIconClass z-10"></i>
                                        <Dropdown id="employee"
                                            value={selectApprover}
                                            onChange={(e) => { setSelectApprover(e.value) }}
                                            options={allApproverList}
                                            // disabled={loggedUserRole === "AP" || type==="SAEdit" ? true : false}
                                            disabled={isDisabledApprover===false? false : true}
                                            onKeyDown={e => {
                                                UserList(e)
                                            }}

                                            filter
                                            optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                    </div>
                                </div>

                                {/*-----Period----*/}
                                <div className="w-full">
                                    <div className="">
                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Period <span className='text-[red] pl-0.2'>*</span></label> </div>
                                    <div className="w-full">
                                        <div className="relative custp-calender">
                                            <i className="gusd-calendar text-[#667085] text-sm absolute top-[0.677vw] left-[0.8rem] cstmIconClass z-10"></i>
                                            <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                            <div className="card justify-content-center">
                                                {selectedEmployee === null && !reportId ?
                                                    <div onClick={() => CalendarValidation()}>
                                                        <Calendar
                                                            disabled={true}
                                                            placeholder="Date Range"
                                                            selectionMode="multiple"
                                                            className="w-full h-11" /> </div>

                                                    :
                                                    <Calendar
                                                        onChange={(e) => {
                                                            console.log("periodDatesperiodDates eeeee:-",typeof e.value);
                                                            console.log("periodDatesperiodDates:-",periodDates);

                                                            setPeriodDates(null);

                                                            setSelectedDateRecord([]);
                                                            setAbsentDate([])
                                                            //setPeriodDates(e.value)
                                                            const nextMinDate = new Date(e.value);
                                                            //const nextMaxDate = new Date(e.value);
                                                            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                                                            let nextMaxDate = nextMinDate;
                                                            let dayNumber = moment(nextMinDate).day(); //nextMinDate.getDay()
                                                            // if(timeZone !== 'Asia/Calcutta'){
                                                            // dayNumber = dayNumber -1
                                                            // }

                                                            if (dayNumber === 0 || dayNumber === 6) { setPeriodDates([]); toast.error("Please do not select Saturday or Sunday."); return }


                                                            let newDate = nextMinDate
                                                            let nextDate = nextMinDate.getDate()
                                                            nextMinDate.setDate(nextMinDate.getDate() - (dayNumber - 2));
                                                            let from = new Date(moment(nextMinDate).format("YYYY-MM-DD"));
                                                            nextMaxDate.setDate(nextMinDate.getDate() + 4);
                                                            //let from = new Date(moment(nextMinDate).format("YYYY-MM-DD"));
                                                            let to = new Date(moment(nextMaxDate).format("YYYY-MM-DD"));
                                                            let dateArray = [from, to];
                                                            setPeriodDates(dateArray)
                                                            //setMinDate(newDate);
                                                            //nextMaxDate.setDate(nextMinDate.getDate() + 4);
                                                            //setMinDate(nextMinDate);
                                                            //setMaxDate(nextMaxDate);
                                                        }}
                                                        value={periodDates}
                                                        minDate={minDate}
                                                        maxDate={maxDate}
                                                        disabled={disabled}
                                                        placeholder="Date Range"
                                                        selectionMode="range"
                                                        className="w-full h-11" />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*-----Period----*/}
                            </div>
                        </div>

                        <div className="mt-5 xl:mt-[1.094vw] pb-10 ">
                            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 xl:gap-[1.250vw]">
                                <div className="col-span-12 lg:col-span-8">
                                    <div id={SelectperiodExpand} className="box-shadow-1 bg-white">
                                        <div className="flex justify-between items-center p-4 xl:p-[0.833vw]">
                                            <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]"><p>Select Period</p></div>
                                            <div className=""><Button href={'/'} onClick={toggleActiveexpand} style={{ background: '#ffffff00', border: '0', padding: '0', width: '24px', height: '24px' }}><i className="gusd-expand text-base text-[#101828]"></i></Button></div>
                                        </div>
                                        <div className="custmCalendar p-4 xl:p-[0.833vw]"> {/****value={absentDate}*/}
                                            <Calendar onChange={(e) => {
                                                if (reportId) { if (selectedEmployee === null) { toast.error("Please Select Employee"); return; } else { onClickDates(e.value); setAbsentDate(e.value); } } else { onClickDates(e.value); setAbsentDate(e.value); }
                                            }}
                                                value={absentDate}
                                                minDate={new Date(moment(periodDates[0]).format("YYYY,M,DD"))}
                                                maxDate={new Date(moment(periodDates[1]).format("YYYY,M,DD"))}
                                                inline
                                                disabledDates={selectedEmployee && selectedEmployee.code ? disabledDates[selectedEmployee.code] : ''}
                                                selectionMode="multiple" />
                                        </div>
                                    </div>


                                    {/*---Preview Section---*/}
                                    <div className="mt-6 xl:mt-[1.250vw]">

                                        {
                                            administratorData.length !== 0 || existingResultsAdministrator.length !== 0 ?
                                                <>

                                                    <div className="p-4 xl:p-[0.833vw] pb-0">
                                                        <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                            <p>Preview - Administrator</p></div></div>
                                                </> : null

                                        }

                                        <div className="bg-white box-shadow-1">

                                            <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable overflow-auto">

                                                <div>
                                                    {
                                                        visible &&
                                                        <Paper>
                                                            <Table>
                                                                <TableHead>
                                                                    {
                                                                        administratorData.length !== 0 || existingResultsAdministrator.length !== 0 ?
                                                                            <TableRow>
                                                                                <TableCell>Name of Employee</TableCell>
                                                                                <TableCell>
                                                                                    Dates Absent</TableCell>
                                                                                <TableCell>Absent Codes</TableCell>
                                                                                <TableCell>Total Hours</TableCell>
                                                                                <TableCell>Name of Substitute</TableCell>
                                                                                <TableCell>Action</TableCell>
                                                                            </TableRow> : null
                                                                    }
                                                                </TableHead>

                                                                <TableBody>
                                                                    {
                                                                        (administratorData.length !== 0 ? administratorData : existingResultsAdministrator).map((item, i) => (
                                                                            <Fragment>
                                                                                {
                                                                                    administratorData.length !== 0 || existingResultsAdministrator.length !== 0 ?
                                                                                        <TableRow>
                                                                                            <TableCell
                                                                                                rowSpan={item.employeeResponse.length + 1}
                                                                                            >
                                                                                                {(reportId) ?
                                                                                                    <Link className=' show default overflow-hidden truncate w-5 underline text-blue-600 hover:text-blue-800 visited:text-purple-600 ' onClick={() => {
                                                                                                        onClickUpdateFollow(i, item)
                                                                                                    }}> {item.employeeName}</Link> : item.employeeName
                                                                                                }
                                                                                            </TableCell>
                                                                                        </TableRow> : null

                                                                                }


                                                                                {item.employeeResponse.map((detail, detailIndex) => (

                                                                                    <TableRow>
                                                                                        <TableCell>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                        <TableCell>{detail.absentCode.name}</TableCell>
                                                                                        {detail.is_full_day ?
                                                                                            <TableCell>
                                                                                                {fullDay}
                                                                                            </TableCell>
                                                                                            :
                                                                                            <TableCell>
                                                                                                {detail.hour === null + "." && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') === null ? detail.hour : detail.hour + "." === null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" !== null ? Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + "min" : detail.hour + "." + Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr"}</TableCell>
                                                                                        }

                                                                                        <TableCell>{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                        <TableCell>
                                                                                            <div className='grid grid-cols-2 gap-2'>
                                                                                            <Link className='pi pi-trash ml-3  ' onClick={() => {
                                                                                                onClickRemove(i, detailIndex, detail, item)
                                                                                            }}></Link>
                                                                                            {detail.isWrong?<i className="pi pi-ban" style={{ color: 'red' }}></i>:<></>}
                                                                                            </div>
                                                                                            </TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </Fragment>
                                                                        ))
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </Paper>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            CertificatedDatas.length !== 0 || existingResultsCertifiedCertificated.length !== 0 ?
                                                <>

                                                    <div className="p-4 xl:p-[0.833vw] pb-0">
                                                        <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                            <p>Preview - Certificated</p>
                                                        </div>
                                                    </div>

                                                </> : null

                                        }

                                        <div className="bg-white box-shadow-1">

                                            <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable overflow-auto">
                                                {
                                                    visible &&
                                                    <Paper>
                                                        <Table>

                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Name of Employee</TableCell>
                                                                    <TableCell>
                                                                        Dates Absent</TableCell>
                                                                    <TableCell>Absent Codes</TableCell>
                                                                    <TableCell>Total Hours</TableCell>
                                                                    <TableCell>Name of Substitute</TableCell>
                                                                    <TableCell>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {

                                                                    (CertificatedDatas.length !== 0 ? CertificatedDatas : existingResultsCertifiedCertificated).map((item, i) => (

                                                                        <Fragment>
                                                                            <TableRow>
                                                                                <TableCell
                                                                                    rowSpan={item.employeeResponse.length + 1}
                                                                                >
                                                                                    {(reportId) ?
                                                                                        <Link className=' show default overflow-hidden truncate w-5 underline text-blue-600 hover:text-blue-800 visited:text-purple-600 ' onClick={() => {
                                                                                            onClickUpdateFollow(i, item)
                                                                                        }}> {item.employeeName}</Link> : item.employeeName
                                                                                    }
                                                                                </TableCell>
                                                                            </TableRow>
                                                                            {item.employeeResponse.map((detail, detailIndex) => (

                                                                                <TableRow>
                                                                                    <TableCell>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                    <TableCell>{detail.absentCode.name}</TableCell>

                                                                                    {detail.is_full_day ?
                                                                                        <TableCell>
                                                                                            {fullDay}
                                                                                        </TableCell>
                                                                                        :
                                                                                        <TableCell>

                                                                                            {detail.hour === null + "." && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') === null ? detail.hour : detail.hour + "." === null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" !== null ? Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + "min" : detail.hour + "." + Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr"}</TableCell>
                                                                                    }

                                                                                    <TableCell>{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                    <TableCell>
                                                                                        <div className='grid grid-cols-2 gap-2'>
                                                                                        <Link className='pi pi-trash ml-3  ' onClick={() => {
                                                                                            onClickRemove(i, detailIndex, detail, item)
                                                                                        }}></Link>
                                                                                        {detail.isWrong?<i className="pi pi-ban" style={{ color: 'red' }}></i>:<></>}
                                                                                        </div>
                                                                                        </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </Fragment>
                                                                    ))
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </Paper>
                                                }

                                            </div>
                                        </div>





                                        <div className=" mt-10 ">

                                            <h3 className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw] block" >Comment</h3>
                                            <div className=" flex flex-wrap xl:flex-nowrap gap-4 xl:gap-[0.938vw]">




                                                <textarea placeholder='' value={comment ? comment : ''} onChange={(e) => setComment(e.target.value)} rows="4" cols="50" type="text" className=" text-[#344054] text-[16px] a rounded-lg disabled bg-[#fff] flex-1 appearance-none border border-[#D0D5DD]  py-2 px-4 bg-grey text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500  placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#8E8E8E]" ></textarea>

                                            </div>
                                        </div>



                                    </div>
                                    {/*---Preview Section---*/}
                                    <div className="mt-[1.250vw]">
                                        <div className="flex flex-wrap justify-between items-center">
                                            <div className="">
                                                <Link to={
                                                 (type==="SAEdit")?'/weekly_absent_report_certificated_admin/SuperAdminDashboard':
                                                 loggedUserRole === 'AP' ? '/approver/weekly_absent_report_certificated_admin/' + reportId :
                                                  '/initiator/weekly_absent_report_certificated_admin'} className="text-[#344054] text-xs xl:text-[0.938vw] font-medium bg-white inline-block border border-[#D0D5DD] rounded xl:rounded-lg py-[0.833vw] px-[2.017vw] box-shadow-2"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i>Previous</Link></div>
                                            {
                                                visible &&
                                                <div className="space-x-4">

                                                    <button onClick={handlePrint} className="font-medium inline-block text-[#FFFFFF] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] border border-[#F2F4F7]"><i className="mr-3 gusd-print-outline"></i>Print</button>

                                                    {
                                                        (isPendingRequest) || (type==="copyReport") ?
                                                            <Link onClick={() => saveReport(Request_Status.O)} className="font-medium inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#EFF8FF] border border-[#D0D5DD]">
                                                                <i class="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save</Link>
                                                            : null
                                                    }

                                                    {!reportId ?
                                                        <Link
                                                            disabled={buttonClicked}
                                                            onClick={() => {
                                                                handleClickDisable();
                                                                saveReport(Request_Status.O)
                                                            }} className="font-medium inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#EFF8FF] border border-[#D0D5DD]">
                                                            <i class="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save</Link>
                                                        : null}
                                                        {/* {
                                                            (type==="copyReport")?
                                                            <Link onClick={() => saveReport(Request_Status.O)} className="font-medium inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#EFF8FF] border border-[#D0D5DD]">
                                                                <i class="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save1</Link>
                                                            : null
                                                        } */}
                                                    <Link onClick={() => {
                                                        setVisibleDialogue(true)
                                                    }} className="font-medium inline-block text-[#FFFFFF] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] border border-[#F2F4F7]">Submit</Link>
                                                </div>
                                            }


                                            {/* print layout start */}
                                            <div style={{ display: "none" }} >


                                                <div ref={componentRef} className='printTable' id='divname'>
                                                    <table className="print-component w-full">
                                                        <thead className="table-header">
                                                            <tr>
                                                                <th>
                                                                    <div>
                                                                        {<>

                                                                            <div style={{ marginTop: "20px" }}>
                                                                                <center className='font-bold text-[20px]' >GLENDALE UNIFIED SCHOOL DISTRICT
                                                                                </center>
                                                                                <center className='font-bold'>Weekly Absence Report - Certificated
                                                                                </center>
                                                                                <p className='float-right'><span className='font-bold'>School or Dept. :- </span>{selectedSchool?.name} </p><br />

                                                                                <p className='float-right'><span className='font-bold'>Period From :- </span>{moment(periodDates[0], "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}  </p><br />

                                                                                <p className='float-right'><span className='font-bold'>Period To :- </span>{moment(periodDates[1], "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</p>
                                                                                <br />
                                                                            </div>
                                                                        </>}
                                                                    </div>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    {<div>
                                                                        <p className='float-left' ><span className='font-bold'>Comment :- </span>{comment} </p>
                                                                        <br />


                                                                        {
                                                                            existingResultsAdministrator.length !== 0 ?
                                                                                <>
                                                                                    <div className='mt-8 font-bold' >Administrator
                                                                                    </div>
                                                                                    {/* <table style={{ width: "100%", marginTop: "20px" }}>
                                                                    <tr>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }} >Name of Employee</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Dates Absent</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Absent Code</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Substitute</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Total Hours</th>
                                                                    </tr>
                                                                    {
                                                                        existingResultsAdministrator.map((item) => {

                                                                            let empResp = item.employeeResponse;
                                                                            for (let i = 0; i <= 3; i++) {
                                                                                return (
                                                                                    <tr className='text-center'>
                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{empResp[i].employeeName}</td>
                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{empResp[i].displayDate}</td>
                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{empResp[i].hour}</td>

                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                            // return (
                                                                            //     <tr className='text-center'>
                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeName}</td>
                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeResponse[0].displayDate}</td>

                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_code_id}</td>
                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                                            //         <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                                            //     </tr>
                                                                            // );
                                                                            // })
                                                                        })
                                                                    }

                                                                </table> */}



                                                                                    {/* ------------------------ */}
                                                                                    <Table>

                                                                                        <TableHead>
                                                                                            <TableRow>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >Name of Employee</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >
                                                                                                    Dates Absent</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >Absent Codes</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >Total Hours</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >Name of Substitute</TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {
                                                                                                (administratorData.length !== 0 ? administratorData : existingResultsAdministrator).map((item, i) => (
                                                                                                    <Fragment>
                                                                                                        {
                                                                                                            administratorData.length !== 0 || existingResultsAdministrator.length !== 0 ?
                                                                                                                <TableRow>
                                                                                                                    <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}
                                                                                                                        rowSpan={item.employeeResponse.length + 1}
                                                                                                                    >
                                                                                                                        {(reportId) ?
                                                                                                                            <Link className=' show default overflow-hidden truncate w-5 underline text-blue-600 hover:text-blue-800 visited:text-purple-600 ' onClick={() => {
                                                                                                                                onClickUpdateFollow(i, item)
                                                                                                                            }}> {item.employeeName}</Link> : item.employeeName
                                                                                                                        }
                                                                                                                    </TableCell>
                                                                                                                </TableRow> : null

                                                                                                        }


                                                                                                        {item.employeeResponse.map((detail, detailIndex) => (

                                                                                                            <TableRow>
                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >{detail.absentCode.name}</TableCell>
                                                                                                                {detail.is_full_day ?
                                                                                                                    <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >
                                                                                                                        {fullDay}
                                                                                                                    </TableCell>
                                                                                                                    :
                                                                                                                    <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >
                                                                                                                        {detail.hour === null + "." && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') === null ? detail.hour : detail.hour + "." === null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" !== null ? Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + "min" : detail.hour + "." + Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr"}</TableCell>

                                                                                                                }

                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                                            </TableRow>
                                                                                                        ))}
                                                                                                    </Fragment>
                                                                                                ))
                                                                                            }
                                                                                        </TableBody>
                                                                                    </Table>

                                                                                </> : null
                                                                        }

                                                                        {
                                                                            existingResultsCertifiedCertificated.length !== 0 ?
                                                                                <>
                                                                                    <div className='mt-8 font-bold' >Certificated
                                                                                    </div>
                                                                                    <Table>

                                                                                        <TableHead>
                                                                                            <TableRow>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }}>Name of Employee</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }}>
                                                                                                    Dates Absent</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }}>Absent Codes</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }}>Total Hours</TableCell>
                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px", fontWeight: "bold" }} >Name of Substitute</TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>
                                                                                        <TableBody>
                                                                                            {

                                                                                                (CertificatedDatas.length !== 0 ? CertificatedDatas : existingResultsCertifiedCertificated).map((item, i) => (

                                                                                                    <Fragment>
                                                                                                        <TableRow>
                                                                                                            <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}
                                                                                                                rowSpan={item.employeeResponse.length + 1}
                                                                                                            >
                                                                                                                {(reportId) ?
                                                                                                                    <Link className=' show default overflow-hidden truncate w-5 underline text-blue-600 hover:text-blue-800 visited:text-purple-600 ' onClick={() => {
                                                                                                                        onClickUpdateFollow(i, item)
                                                                                                                    }}> {item.employeeName}</Link> : item.employeeName
                                                                                                                }
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        {item.employeeResponse.map((detail, detailIndex) => (

                                                                                                            <TableRow>
                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>

                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }} >{detail.absentCode.name}</TableCell>
                                                                                                                {detail.is_full_day ?
                                                                                                                    <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                                                                                        {fullDay}
                                                                                                                    </TableCell>
                                                                                                                    :
                                                                                                                    <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}>

                                                                                                                        {detail.hour === null + "." && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') === null ? detail.hour : detail.hour + "." === null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" !== null ? Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + "min" : detail.hour + "." + Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr"}</TableCell>

                                                                                                                }
                                                                                                                <TableCell style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{detail.nameOfTheSubstitute.name}</TableCell>

                                                                                                            </TableRow>
                                                                                                        ))}
                                                                                                    </Fragment>
                                                                                                ))
                                                                                            }
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </> : null
                                                                        }

                                                                        {/* {
                                                        CertificatedDatas.length !== 0 ?
                                                            <>
                                                                <div className='mt-8 font-bold' >Certificated
                                                                </div>
                                                                <table style={{ width: "100%", marginTop: "20px" }}>
                                                                    <tr>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }} >Name of Employee</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Dates Absent</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Absent Code</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Substitute</th>
                                                                        <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Total Hours</th>
                                                                    </tr>
                                                                    {
                                                                        certificatedDatas.map((item) => {
                                                                            return (
                                                                                <tr className='text-center'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeName}</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_code_id}</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }

                                                                </table>
                                                            </> : null
                                                    } */}

                                                                        {/*
                                                    {administratorData.length === 0 && CertificatedDatas === 0 ?
                                                        <div className='mt-8 font-bold' >No Absence
                                                        </div>
                                                        : null
                                                    } */}
                                                                        <div className='absenceCode'>
                                                                            <div className='mt-8 font-bold' >ABSENCE CODES
                                                                            </div>

                                                                            <table style={{ width: "100%", marginTop: "7px" }}>
                                                                                <tr className='text-[12px]'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>B - Bereavement</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>NA - Personal (Not Approved)</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>S - Suspension</td>
                                                                                </tr>
                                                                                <tr className='text-[12px]'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>D - District Approved</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>OU - Other Unpaid</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>V - Vacation</td>
                                                                                </tr>
                                                                                <tr className='text-[12px]'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>I - Illness</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PA - Personal (Approved)</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>W - Witness (District)</td>
                                                                                </tr>
                                                                                <tr className='text-[12px]'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>J - Jury Duty</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>WC - Worker's Compensation</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>DC - District Covid</td>
                                                                                </tr>
                                                                                <tr className='text-[12px]'>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>L - Last Day Worked</td>
                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PN - Personal Necessity</td>
                                                                                </tr>

                                                                            </table>
                                                                        </div>
                                                                    </div>}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        {/* <tfoot className="table-footer">
            <tr>
                <td>
                    {`Page Number ${1}`}
                </td>
            </tr>
        </tfoot> */}
                                                    </table>
                                                </div>

                                            </div>
                                            {/* print layout end */}
                                            {/* --------------------------------------------------------------------------- */}

                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-12 lg:col-span-4">
                                    <div className="bg-white box-shadow-1 p-4 rounded-lg xl:p-[0.833vw]">
                                        <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Selected Dates</p></div>
                                        {
                                            (indexEditMode && selectedItem) ?
                                                selectedDateRecordNew.length && selectedDateRecordNew.map((currentItem, i) => {
                                                    return (
                                                        <>
                                                            <div key={i}>
                                                                <div className="mt-[24px] xl:mt-[1.250vw]">
                                                                    <div className="text-[#344054] font-normal text-xs xl:text-[0.625vw] flex flex-wrap items-center justify-between lg:flex-nowrap"><p className="w-full lg:w-[7.813vw] text-[11px] font-bold">{moment(currentItem.displayDate).format("D MMMM YYYY")}</p><span className="w-full h-[1px] bg-[#E4E7EC] inline-block"></span></div>
                                                                </div>
                                                                <div className="mt-[16px] xl:mt-[0.833vw]">
                                                                    <div className="bg-[#F2F4F7] rounded p-2 xl:p-[0.417vw] custseledate">
                                                                        <div className="w-full">
                                                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Absent Code <span className='text-[red] pl-0.2'>*</span></label>
                                                                            <Dropdown value={currentItem.absentCode} onChange={(e) => { onClickAbsentCode(i, e) }} options={absentCodeListDropdown}
                                                                                filter
                                                                                optionLabel="name" placeholder="Select an Absent Code" className="w-full h-7 absent" />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <label htmlFor="substitute" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Substitute </label>

                                                                            <InputText id="substitute"
                                                                                value={currentItem.nameOfTheSubstitute.name ? currentItem.nameOfTheSubstitute.name : ''}
                                                                                onChange={(e) => onClickNameOfSubstitute(i, e)}

                                                                                placeholder="Name of Substitute" className="w-full h-7 rounded-md border border-[#E4E7EC] " style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />


                                                                            {/*<Dropdown value={currentItem.nameOfTheSubstitute} onChange={(e) => onClickNameOfSubstitute(i, e)} options={updatedEmpList}
                                                                            filter
																		optionLabel="name" placeholder="Select a Substitute" className="w-full h-7" /> */}
                                                                        </div>

                                                                        <div className="p-[8px] mt-[5px] xl:mt-[0.380vw] xl:p-[0.417vw]">
                                                                            <div className="flex flex-wrap gap-3">
                                                                                {
                                                                                    <div className="">
                                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Total Hours<span className='text-[red] '>*</span></label>
                                                                                        <div className="flex">

                                                                                            <div className="relative custinput-h">

                                                                                                <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>H</p></div>
                                                                                                <InputNumber value={currentItem.hour}
                                                                                                    maxLength={1} max="8"
                                                                                                    disabled={currentItem.is_full_day ? true : false}
                                                                                                    onValueChange={(e) => { onClickHoure(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                            </div>

                                                                                            <div className="relative custinput-m">
                                                                                                <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC] rounded-br-[5px] rounded-tr-[5px]"><p>M</p></div>
                                                                                                <InputNumber value={isNaN(currentItem.minute) ? 0 : currentItem.minute} onValueChange={(e) => { onClickMin(i, e.target.value) }}
                                                                                                    maxLength={2} max="59"
                                                                                                    disabled={currentItem.hour === 8 || currentItem.hour === '8' || currentItem.is_full_day ? true : false}
                                                                                                    className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                            </div>


                                                                                            <div className="ml-5 w-full">

                                                                                                <input type="checkbox" check id={i} value={currentItem.is_full_day} checked={currentItem.is_full_day} onChange={(e) => { setFlagToFullDay(i, e) }} className="checkbox mt-2" />

                                                                                                <label htmlFor="substitute" className="text-[#344054] text-xs xl:text-[0.833vw] font-semibold -tracking-[0.02em]"> Full day</label>

                                                                                            </div>


                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })

                                                :


                                                selectedDateRecord.map((currentItem, i) => {
                                                    return (
                                                        <>
                                                            <div key={i}>
                                                                <div className="mt-[24px] xl:mt-[1.250vw]">
                                                                    <div className="text-[#344054] font-normal text-xs xl:text-[0.625vw] flex flex-wrap items-center justify-between lg:flex-nowrap"><p className="w-full lg:w-[7.813vw] text-[11px] font-bold">{moment(currentItem.displayDate).format("D MMMM YYYY")}</p><span className="w-full h-[1px] bg-[#E4E7EC] inline-block"></span></div>
                                                                </div>
                                                                <div className="mt-[16px] xl:mt-[0.833vw]">
                                                                    <div className="bg-[#F2F4F7] rounded p-2 xl:p-[0.417vw] custseledate">
                                                                        <div className="w-full">
                                                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Absent Code <span className='text-[red] pl-0.2'>*</span></label>
                                                                            <Dropdown value={currentItem.absentCode} onChange={(e) => { onClickAbsentCode(i, e) }} options={absentCodeListDropdown}
                                                                                filter
                                                                                optionLabel="name" placeholder="Select an Absent Code" className="w-full h-7 absent" />
                                                                        </div>

                                                                        <div className="w-full">
                                                                            <label htmlFor="substitute" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Substitute </label>

                                                                            <InputText id="substitute"
                                                                                value={currentItem.nameOfTheSubstitute.name ? currentItem.nameOfTheSubstitute.name : ''}
                                                                                onChange={(e) => onClickNameOfSubstitute(i, e)}

                                                                                placeholder="Name of Substitute" className="w-full h-7 rounded-md border border-[#E4E7EC] " style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />


                                                                            {/*<Dropdown value={currentItem.nameOfTheSubstitute} onChange={(e) => onClickNameOfSubstitute(i, e)} options={updatedEmpList}
                                                                            filter
																		optionLabel="name" placeholder="Select a Substitute" className="w-full h-7" /> */}
                                                                        </div>

                                                                        <div className="p-[8px] mt-[5px] xl:mt-[0.380vw] xl:p-[0.417vw]">
                                                                            <div className="flex flex-wrap gap-3">
                                                                                {
                                                                                    <div className="">
                                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Total Hours<span className='text-[red] '>*</span></label>
                                                                                        <div className="flex">

                                                                                            <div className="relative custinput-h">

                                                                                                <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>H</p></div>
                                                                                                <InputNumber value={currentItem.hour}
                                                                                                    maxLength={1} max="8"
                                                                                                    disabled={currentItem.is_full_day ? true : false}
                                                                                                    onValueChange={(e) => { onClickHoure(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                            </div>

                                                                                            <div className="relative custinput-m">
                                                                                                <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC] rounded-br-[5px] rounded-tr-[5px]"><p>M</p></div>
                                                                                                <InputNumber value={isNaN(currentItem.minute) ? 0 : currentItem.minute} onValueChange={(e) => { onClickMin(i, e.target.value) }}
                                                                                                    maxLength={2} max="59"
                                                                                                    disabled={currentItem.hour === 8 || currentItem.hour === '8' || currentItem.is_full_day ? true : false}
                                                                                                    className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                            </div>

                                                                                            <div className="ml-5 w-full">

                                                                                                <input type="checkbox" check id={i} value={currentItem.is_full_day} checked={currentItem.is_full_day} onChange={(e) => { setFlagToFullDay(i, e) }} className="checkbox mt-2" />

                                                                                                <label htmlFor="substitute" className="text-[#344054] text-xs xl:text-[0.833vw] font-semibold -tracking-[0.02em]"> Full day</label>

                                                                                            </div>

                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )

                                                })



                                        }
                                        {
                                            selectedDateRecord >= 0 ? null :
                                                isApply ?
                                                    <div className="custbutn mt-6 xl:mt-[1.250vw]">
                                                        <Button className="" label={showPleaseWaitButton ? 'Please wait...' : 'Apply'} disabled={reportId && (selectedDateRecord.length === employeeWiseMapp) ? false : false} onClick={() => {
                                                            applyReport()
                                                        }}>
                                                        </Button>
                                                    </div>
                                                    : null

                                        }



                                    </div>

                                    <div className="bg-white box-shadow-1 p-4 mt-6 rounded-lg xl:p-[0.833vw] xl:mt-[1.250vw]">
                                        <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Absence Codes - Legends</p></div>
                                        <div className="flex flex-wrap xl:flex-nowrap gap-4 mt-5 xl:gap-[0.938vw] xl:mt-[1.250vw]">


                                            <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                {absentCodeList.length > 0 && absentCodeList.slice(0, 7).map((item, index) => {
                                                    return (<>
                                                        <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                    </>
                                                    )
                                                })}
                                            </div>

                                            <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                {absentCodeList.length > 0 && absentCodeList.slice(7, 14).map((item, index) => {
                                                    return (<>
                                                        <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                    </>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>




                                    <div className="dialogpoput flex justify-content-center ">
                                        <Dialog visible={visibleDialogue} position="center" style={{ width: '30vw' }} className="dialogpoput dialogres submit_popup" onHide={() => setVisibleSumbit(false)}>

                                            <div className="text-[#101828] text-lg py-2 pt-5 font-bold text-center">Submit Report</div>
                                            <div className="text-[#344054] text-xs pb-2 font-medium">Your report will be sent for review, you will be notified of updates.</div>

                                            <div className="pt-2 flex pb-[-2px] justify-center gap-2">
                                                <Link href={''} className="custmBtn3 rounded-lg text-[black] text-center bg-[White]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                }}
                                                > Cancel
                                                </Link>
                                                <Link href={''} className="custmBtn3 rounded-lg text-[#FFFFFF] text-center bg-[#113699]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                    saveReport(approver_status === CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_REJECTED ?
                                                        CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED :
                                                        CertificatedAdminWeeklyAbsenceReportStatus.SUBMITTED
                                                    )
                                                }}
                                                >Send
                                                </Link>
                                            </div>

                                        </Dialog>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </Layout >
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}